<!--begin header -->
<header class="header">
    <app-header></app-header>
</header>
<!--end header -->
    <!-- Bootstrap FAQ - START -->
    <section  *ngIf="country == 'sg'">
        <!--begin services-wrapper -->
        <div class="services-wrapper">
            <!--begin container -->
            <div class="container">
                <br />
                <br />
                <br />
            
            
                <br />
            
                <div class="panel-group FAQ" id="accordion"> 
                <div>
                    <h1 style="font-size: 34px; color: #FF6600; font-weight: 500;">Frequently Asked Questions (FAQs)</h1>
                 </div>
                    <div class="faqHeader">General</div>
                    <div class="panel panel-default">
                        <div class="panel-heading">
                            <h4 class="panel-title">
                                <a class="accordion-toggle" data-toggle="collapse" data-parent="#accordion" href="#collapseOne">1. Am I eligible to sign up?</a>
                            </h4>
                        </div>
                        <div id="collapseOne" class="panel-collapse collapse in">
                            <div class="panel-body">
                                <p> If you are a resident of Singapore, you can sign up with us. It's simple and free, so <a href="javascript:void(0)" (click)="redirectToRegistrationPage()">start now.</a></p>
                                
                            </div>
                        </div>
                    </div>
                    <div class="panel panel-default">
                        <div class="panel-heading">
                            <h4 class="panel-title">
                                <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapseTen">2. How long does it take?</a>
                            </h4>
                        </div>
                        <div id="collapseTen" class="panel-collapse collapse">
                            <div class="panel-body">
                                <p> You can send money to more than 30 countries. Please <a routerLink="/country-details" style="cursor:pointer; color: blue;">click here</a> to view details.</p>
                               
                            </div>
                        </div>
                    </div>
                    <div class="panel panel-default">
                        <div class="panel-heading">
                            <h4 class="panel-title">
                                <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapseEleven">3. How much does it cost?</a>
                            </h4>
                        </div>
                        <div id="collapseEleven" class="panel-collapse collapse">
                            <div class="panel-body">
                                <p>
                                    We charge a small fee, between 0.25% and 1% of the <span nz-tooltip
                                    nzTooltipTitle="The mid-market rate is the rate with no exchange mark-up. This is the rate at which the big banks trade money with each other, and it is the rate you will find on independent sources such as Google or XE.com. In short, it is the best exchange rate you can get at any point of time." style="color: blue;">mid-market rate</span>  For stable and frequently traded currencies the fee is closer to 0.5%, and for more volatile and less frequently traded currencies the fee is higher (up to 1%). Check out the <a routerLink="/"  style="cursor:pointer; color: blue;">Fair Exchange Calculator</a> to find out the exact fee we charge and how much you save by transacting through us. 
                                    Our charges are fully transparent so that there are no surprises. Unlike banks or other money transfer operators, there are no hidden charges, no cable fees, no bank commissions, and no hefty foreign exchange mark-ups.
                                </p>
                            
                            </div>
                        </div>
                    </div>

                    <div class="panel panel-default">
                        <div class="panel-heading">
                            <h4 class="panel-title">
                                <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapsetwelve">4. How long does it take?</a>
                            </h4>
                        </div>
                        <div id="collapsetwelve" class="panel-collapse collapse">
                            <div class="panel-body">
                                <p>
                                    After we have received your money, it will typically take us a few hours to credit your nominated receiver's bank account in most cases. However, it will vary depending on the receiver country and banks, for more details on processing times, please <a routerLink="/country-details" style="color: blue;"> click here</a>.
                                </p>
                                
                            </div>
                        </div>
                    </div>

                    <div class="panel panel-default">
                        <div class="panel-heading">
                            <h4 class="panel-title">
                                <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapsethirteen">5.  Is my money safe?</a>
                            </h4>
                        </div>
                        <div id="collapsethirteen" class="panel-collapse collapse">
                            <div class="panel-body">
                                <p> The safety of your money is as important to us, as it is to you. Your money is safe with us for 4 reasons:</p>
                                <ol>
                                    <li><p><b>Your funds are kept in a segregated client account.</b><br>As a regulated payment services provider, we must hold all money transferred by our clients in segregated bank accounts. These accounts are separate from our own bank accounts. So, your money is never mixed with ours, and we cannot use your money to settle any of our own obligations.</p></li>
                                    <li><p><b>We have a credible and trustworthy team.</b><br>
                                    The Shareholders and Directors of SingX are professionals who have worked with reputed multinational banks throughout their careers. They operate with the highest levels of integrity. Click <a routerLink="/team" style="color: blue;">here</a> to read about the profiles of our key management.</p></li>
                                    <li>
                                        <p><b>We work with Licensed Remittance Operators (LROs) in each country. </b><br>
						
                                        These LROs are licensed to do remittance transactions by the Central Bank in their respective countries. Click <a routerLink="/licenses">here</a>
                                        for more details on the licensed entities we deal with.
                                    </li>
                                    <li>
                                        <p><b>We implement a host of security measures, just like the banks.</b><br>
                                            We take the safety of your personal details very seriously. To facilitate secure data transmission over the Internet, we have all the
                                               <span nz-tooltip
                                               nzTooltipTitle="System integrity and the confidentiality of your personal and transaction details are our top priority.
                                               For data to be transmitted securely over the Internet, we use Secure Socket Layer (SSL), 128-bit encryption within the logged-in site pages. To check if your connection is secure, just look for the https url and the secure padlock symbol at the bottom right of your browser window or in the address bar.
                                               All data is held on secure servers hosted by Data Electronics (ISO 9001:2008 and ISO 27001 certified) along with a managed firewall service as well as guaranteed power and connectivity to provide the highest levels of security 24/7." style="color: blue;">safety precautions</span> 
                                          in place. We have adopted a <span nz-tooltip
                                          nzTooltipTitle=" Two-factor authentication improves account security by combining what you know, e.g. your password, with something that only you possess, such as your mobile phone. When trying to log in or carry out certain actions, such as transferring money, we will automatically send a One-time Password (OTP) to your phone. Enter the OTP into the two-factor authentication form on our site and you can transact with total peace of mind after that." style="color: blue;">two-step authentication process</span> which ensures complete security and peace of mind. We also ensure that our website keeps your <span nz-tooltip
                                          nzTooltipTitle=" Our website uses 256-bit encryption via Secure Socket Layer (SSL) from VeriSign. This means that your connection is secure." style="color: blue;">connection secure</span> All your account information is stored in a secure facility that is safeguarded by us. </p>
                        
                                </ol>
                            </div>
                        </div>
                    </div>
                    
                    <div class="panel panel-default">
                        <div class="panel-heading">
                            <h4 class="panel-title">
                                <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapsefourteen">6. How do I sign up?</a>
                            </h4>
                        </div>
                        <div id="collapsefourteen" class="panel-collapse collapse">
                            <div class="panel-body">
                                <ol class=" color_lightgrey paddingbullet" style="list-style-type: none;" >
										
                                    <li><p><b>Step 1: Check if we support your country of residence.</b><br>If you are a resident of Singapore, you can sign up with us. It's simple and free. <a href="javascript:void(0)" (click)="redirectToRegistrationPage()" style="cursor:pointer;">Start now</a>.</p></li>
                                    <li><p><b>Step 2: Complete your registration online.</b><br>The fastest way to register with SingX is to use Singpass. In case you don't have Singpass, you can register digitally by 
                                        uploading a copy of your NRIC/FIN and taking a selfie! It just takes 5 minutes. Your account will approved within the same day!
                                         <br> <br><a href="javascript:void(0)" (click)="redirectToRegistrationPage()" style="text-decoration: underline; color: blue;">Click to Register Now</a>
                                         <br><br>
                                         For Business Accounts, please write to us at <a routerLink="mailto:help.business@singx.co" >help.business&#64;singx.co</a> and we will take you through the sign-up process.</p></li>
                                    
                                </ol>
                            </div>
                        </div>
                    </div>
            
                    <div class="panel panel-default">
                        <div class="panel-heading">
                            <h4 class="panel-title">
                                <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapsefifteen">7. How do I make a transaction?</a>
                            </h4>
                        </div>
                        <div id="collapsefifteen" class="panel-collapse collapse">
                            <div class="panel-body">
                                <p>Before you start a transaction, make sure that you have completed the <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapsefourteen">sign up process</a> and received an email from us confirming that your account is ready.</p>
                                <ol class=" color_lightgrey paddingbullet" >
                                    <li>
                                    <b>Follow these simple steps to create your transaction:</b> <br>
                                    <Br> On our Fair Exchange Calculator, select the From Currency, To Currency and enter the Send Amount<br>
                                    </li>
                    
                                        <ul class="regular10 color_lightgrey paddingbullet">
                                            <li><p>Click 'Start Your Transfer' to proceed.</p></li>
                                            <li><p>Next, select your payment method: </p></li>
                                            <p>1. SingX Wallet - fund's will automatically be deducted from your wallet. In order to choose this option you need to make sure your wallet is topped up and has sufficient funds to fulfil the transaction. 
                                                See - how to top up your wallet
                                            </p>
                                            <p>
                                              2. Bank transfer - simply transfer the amount you are sending plus the SingX fee from your local bank account to our local bank account in Singapore using Internet Banking.
                                            </p>
                                        </ul>
                                    <ul class="regular10 color_lightgrey paddingbullet">
                                        <li><p>Enter the receiver's details or select an existing receiver.</p></li>
                                        <li><p>Review transaction details before clicking confirm and entering your SMS OTP.</p></li>
                                        <li><p>If you have chosen the bank transfer option, you will need to login to your internet banking account and send the funds to our local bank account.</p></li>
                                    </ul>
                                    </ol>
                            </div>
                        </div>
                    </div>

                    <div class="panel panel-default">
                        <div class="panel-heading">
                            <h4 class="panel-title">
                                <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapsesixteen">8. How much can I send?</a>
                            </h4>
                        </div>
                        <div id="collapsesixteen" class="panel-collapse collapse">
                            <div class="panel-body">
                                <p> You may transfer up to SGD 1 million. Please <a routerLink="/quicktransfer" style="cursor:pointer; color: blue;">click here</a> to view details.</p>
                                <!-- <p>You may transfer up to SGD 1 million. However, please note that there are some restrictions imposed by countries to which you are sending money.</p>
                                <p><b>India:</b> <br>
                                     As an individual, there is no restriction on how much you can send. <br>
                                     For business payments to India, there is an RBI limit of INR 1,500,000 per transaction. However, there is no limit on the number of transactions that businesses can place in a day. <br>
                                </p>
                                <p><b>Malaysia:</b> <br>
					
                                    <p>The maximum amount you can send to Malaysia is RM 150,000. However, please note that if your receiver is not a Malaysian national, banks may impose a lower transaction threshold (typically RM 10,000). As for remittances into bank accounts into Malaysia we may need supporting documents (eg. Invoices) for any payments above RM 50,000 and also for transactions where the receiver's bank may ask for clarifications from time to time, to fulfil their regulatory compliance requirements.
                                    
                                </p>
                                
                                <p><b>Indonesia:</b> <br>
                                
                                    <p>The maximum amount you can send to Indonesia is IDR 999,999,999 per transaction. However, there is no limit on the number of transactions you place. 
                                    </p>
                                
                                
                                <p><b>Philippines:</b> <br>
                                
                                    <p>The maximum amount you can send to Philippines is PHP 500,000 per transaction. However, there is no limit on the number of transactions you place.
                                </p>
                                <p><b>Thailand:</b> <br>
                                
                                    <p>Thailand: For individuals, the maximum amount you can send to Thailand is THB 150,000 per transaction. For payments to businesses in Thailand, the maximum amount you can send to Thailand is THB 1,500,000 per transaction
                                </p>
                                <p><b>United States of America:</b> <br>
                                
                                    <p>For payments to individuals and businesses, the maximum amount you can send to USA is USD 75,000 per transaction.
                                </p>
                                <p><b>United Kingdom:</b> <br>
                                    <p>For payments to individuals and businesses, the maximum amount you can send to UK is GBP 250,000 per transaction. 
                                </p>
                                <p><b>Canada, European countries, Australia: No limit</b></p> -->
                            </div>
                        </div>
                    </div>

                    <div class="panel panel-default">
                        <div class="panel-heading">
                            <h4 class="panel-title">
                                <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapseseventeen">9. How can I contact SingX?</a>
                            </h4>
                        </div>
                        <div id="collapseseventeen" class="panel-collapse collapse">
                            <div class="panel-body">
                                Should you require assistance of any kind, you can email our Customer Care at <a href="mailto:help@singx.co" >help&#64;singx.co</a>.You can contact our customer service agents via our 'Live Chat' or Hotline (+65-3158-4669) between 9 am to 6 pm (Monday to Friday), or leave an offline message via the chat outside these operating hours.
                            </div>
                        </div>
                    </div>

                    <div class="faqHeader">Basic Information</div>
                    <div class="panel panel-default">
                        <div class="panel-heading">
                            <h4 class="panel-title">
                                <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapseTwo">Why should I use SingX?</a>
                            </h4>
                        </div>
                        <div id="collapseTwo" class="panel-collapse collapse">
                            <div class="panel-body">
                                <p>Here are 3 compelling reasons why you should use SingX for cross-border money transfers and international payments:</p>
                                <ol class=" color_lightgrey paddingbullet"  >
                                                                
                                <li><p><b>Enjoy great savings </b><br>You save up to 8% of the transaction amount every time you transfer money through us. Banks and other operators will usually charge you a hefty mark-up on the foreign exchange rate and have layers of hidden fees like cable charges and commission. SingX only charges a single small transparent fee. </p></li>
                                <li><p><b>Enjoy speedy transfers </b><br>After we have received your money, it will take us between 1 and 3 working days to credit your nominated receiver's bank account, depending on the speed of Internet Banking transfers in the receiver's country. For more details on processing times, please <a routerLink="/country-details" style="color: blue;">click here</a>.  
                                </li>
                                <li><p><b>Enjoy the online convenience </b><br>Say goodbye to filling in complicated wire transfer forms, signing and delivering original documents to your bank branch only to learn that you have filled the form incorrectly. With us, it's way simpler. Your information is stored with us. You simply confirm that you are happy with the exchange rate and then transfer money to us online.</p></li>
                                                                    
                                </ol>
                            </div>
                        </div>
                    </div>
                    <div class="panel panel-default">
                        <div class="panel-heading">
                            <h4 class="panel-title">
                                <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapseThree">Which countries can I transfer money from?</a>
                            </h4>
                        </div>
                        <div id="collapseThree" class="panel-collapse collapse">
                            <div class="panel-body">
                                <p>Currently, we offer transfers from Singapore, Australia and Hong Kong. </p>
                            </div>
                        </div>
                    </div>
            
                    <div class="faqHeader">Signing Up</div>
                    <div class="panel panel-default">
                        <div class="panel-heading">
                            <h4 class="panel-title">
                                <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapseFour">What is the registration process?</a>
                            </h4>
                        </div>
                        <div id="collapseFour" class="panel-collapse collapse">
                            <div class="panel-body">
                                <ol class=" color_lightgrey paddingbullet" style="list-style-type: none;" >
										
                                    <li><p><b>Step 1: Check if we support your country of residence.</b><br>If you are a resident of Singapore, you can sign up with us. It's simple and free. <a href="javascript:void(0)" (click)="redirectToRegistrationPage()" style="cursor:pointer;">Start now</a>.
                                    </p></li>
                                    <li><p><b>Step 2: Complete your registration online.</b><br>Our sign up is 100% digital and only takes a few minutes! We offer 3 easy options:</p></li><br>
                                   <li> 1.   Register via MyInfo - quick and easy registration through MyInfo login</li>
                                    <li>2.   Selfie-based Registration - requires uploading of your ID document (front and back) and taking a live selfie</li>
                                    <li>3.   Mobile-bill based Registration - requires uploading of your post-paid mobile bill and ID document (front and back)</li><br>
                                    <li>For businesses, please write to us at <a href="mailto:help@singx.co">help&#64;singx.co</a> and we will take you through the sign-up process.</li><br>
                                   <p>Once we have verified all your documents, you will receive a confirmation email from us. After this, you are on your way to enjoying a cheaper, faster, more convenient way of transferring money across borders with us.</p>
                                    
                                </ol>
                            </div>
                        </div>
                    </div>
                    <div class="panel panel-default">
                        <div class="panel-heading">
                            <h4 class="panel-title">
                                <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapseSeven">What documents are required? </a>
                            </h4>
                        </div>
                        <div id="collapseSeven" class="panel-collapse collapse">
                            <div class="panel-body">
                                We currently offer 3 methods of signing up for an individual account:<br><br>
                                <ol class=" color_lightgrey paddingbullet" style="list-style-type: decimal;" >
                                    <li><b>Singpass Login - </b>if you have a valid Singpass account, you can do a quick sign up via this method. We'll only require a proof of address document if you are not a Singaporean or Singapore Permanent Resident.</li>
                                    <br>
                                    <li>
                                        <b>E-Verification method - </b>
                                        <ul>
                                            <li>Photo Identification Document (ID)</li>
                                            <li>Mobile Bill - post paid bill showing your registered mobile number and address, not more than 3 months old. </li>
                                            <br>
                                        </ul>
                                    </li>
                                    <li>
                                        <b>Selfie method</b>
                                        <ul>
                                            <li>Photo Identification Document (ID)</li>
                                            <li>Your Selfie</li>
                                            <li>Proof of Address if you are not a Singaporean or Singapore Permanent Resident.
                                                This can be a utility bill, bank statement or credit card statement, which is less than 3 months old.
                                            </li>
                                            <br>
                                        </ul>
                                    </li>
                                </ol>
                                  <p>For business users, please write to us at <a href="mailto:help@singx.co">help&#64;singx.co</a> and we will take you through the sign-up process.</p>
                            </div>
                        </div>
                    </div>

                    <div class="panel panel-default">
                        <div class="panel-heading">
                            <h4 class="panel-title">
                                <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapseeight">Does it cost anything to register with SingX?</a>
                            </h4>
                        </div>
                        <div id="collapseeight" class="panel-collapse collapse">
                            <div class="panel-body">
                                <p>Signing up with us is absolutely free!</p>
                            </div>
                        </div>
                    </div>

                  <!-- my info -->
                  <div class="faqHeader">Signing Up Using MyInfo</div>
                  <div class="panel panel-default">
                      <div class="panel-heading">
                          <h4 class="panel-title">
                              <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse311">What is MyInfo?</a>
                          </h4>
                      </div>
                      <div id="collapse311" class="panel-collapse collapse">
                          <div class="panel-body">
                            <p>MyInfo is a service which that allows SingPass users to manage their personal data and pre-fill forms in online transactions. This includes government-verified data that is retrieved across participating Government agencies and data that you contributed to form your profile.
                                This means that users only need to provide personal data once to the Government, instead of providing data repeatedly for every online transaction
                            </p>
                          </div>
                      </div>
                  </div>
                  <div class="panel panel-default">
                      <div class="panel-heading">
                          <h4 class="panel-title">
                              <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse322">What type of transactions can I perform with SingX using MyInfo services?</a>
                          </h4>
                      </div>
                      <div id="collapse322" class="panel-collapse collapse">
                          <div class="panel-body">
                            <p>MyInfo can be used for registering with SingX without having to do any document uploads or face to face meetings.</p>
                          </div>
                      </div>
                  </div>

                  <div class="panel panel-default">
                      <div class="panel-heading">
                          <h4 class="panel-title">
                              <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse333">Am I required to register for MyInfo?</a>
                          </h4>
                      </div>
                      <div id="collapse333" class="panel-collapse collapse">
                          <div class="panel-body">
                             <p>No registration is required for MyInfo. You are however required to have a valid SingPass account.</p>
                          </div>
                      </div>
                  </div>

                  
                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse344">Am I required to upload any documents using MyInfo?</a>
                        </h4>
                    </div>
                    <div id="collapse344" class="panel-collapse collapse">
                        <div class="panel-body">
                           <p> No document is required to be uploaded using MyInfo for Singaporeans and Permanent Residents. Foreigners are required to upload proof of their residential address.</p>
                        </div>
                    </div>
                  </div>

                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse355">What type of personal data will SingX be accessing from MyInfo?</a>
                        </h4>
                    </div>
                    <div id="collapse355" class="panel-collapse collapse">
                        <div class="panel-body">
                           <p>  We can only request personal data that is required for new applications. Your consent will be sought before your personal data is transferred to us.</p>
                        </div>
                    </div>
                  </div>
                  
                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse356">Can I choose which data I want to share with SingX?</a>
                        </h4>
                    </div>
                    <div id="collapse356" class="panel-collapse collapse">
                        <div class="panel-body">
                           <p> We will be retrieving the full set of relevant data fields from MyInfo. These data fields will be the same as those specified within SingX online forms, and will only be transferred from MyInfo upon your consent.</p>
                        </div>
                    </div>
                  </div>

                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse357">Will SingX be able to use my data for other purposes besides processing my application?</a>
                        </h4>
                    </div>
                    <div id="collapse357" class="panel-collapse collapse">
                        <div class="panel-body">
                           <p> For more information on the purposes and how we process your personal data, please refer to our current <a routerLink="/privacy-policy">Privacy Policy</a></p>
                        </div>
                    </div>
                  </div>

                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse358">The data pre-filled by MyInfo in the application form is incorrect. How can I update the data?</a>
                        </h4>
                    </div>
                    <div id="collapse358" class="panel-collapse collapse">
                        <div class="panel-body">
                           <p> Government-verified fields contain information that has been reasonably verified by the relevant Government agency or Statutory Board upon receipt. It is your responsibility to ensure that all data contained in your Profile, submitted for purposes are complete and accurate. Please contact the relevant Agency to update your Government-verified fields if they are incorrect. Alternatively, you can choose to open the account online without using MyInfo.</p>
                        </div>
                    </div>
                  </div>

                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse359">If there is any change in my information post account opening, will SingX automatically update my records using MyInfo?</a>
                        </h4>
                    </div>
                    <div id="collapse359" class="panel-collapse collapse">
                        <div class="panel-body">
                           <p> We can only receive data that you have consented to share at the point of account opening and will not be notified of any subsequent changes. Should you wish to update your details subsequently, write to us at <a href="mailto:help@singx.co">help&#64;singx.co</a> or edit after logging into www.singx.co</p>
                        </div>
                    </div>
                  </div>

                  <!-- end my info -->

                  <!-- remittance -->
                  <div class="faqHeader">Remittance</div>
                  <div class="faqHeader">Rates, Charges & Savings</div>
                  <div class="panel panel-default">
                      <div class="panel-heading">
                          <h4 class="panel-title">
                              <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse41">What are the real savings?</a>
                          </h4>
                      </div>
                      <div id="collapse41" class="panel-collapse collapse">
                          <div class="panel-body">
                            <p> You will save a lot of money. How much you save will vary, depending on the amount you transfer and the currencies involved. To calculate the savings on a transaction you may be considering, check out our <a routerLink="/" style="cursor:pointer;">Fair Exchange Calculator</a>. <br><br>
                                We constantly compare our fee to that of banks, remittance agents, card companies and others. These operators usually charge you a hefty mark-up on the foreign exchange rate and have layers of hidden fees like cable fees and commissions. <br><br>
                                We save you money by using the mid-market rate. This is the wholesale rate at which the big banks transact with each other. While other retail players apply a 'mark-up' on this rate, we offer the wholesale mid-market rate. We charge a small transparent fee which is shown to you upfront.<br><br>
                                Still not sure? Feel free to compare our rates with those offered by other providers.	
                            </p>
                          </div>
                      </div>
                  </div>
                  <div class="panel panel-default">
                      <div class="panel-heading">
                          <h4 class="panel-title">
                              <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse42">Will I be charged any fees/charges other than what I see in the Fair Exchange Calculator?</a>
                          </h4>
                      </div>
                      <div id="collapse42" class="panel-collapse collapse">
                          <div class="panel-body">
                            <p> Absolutely not. Our changes are fully transparent so there are no surprises. Unlike banks or other money transfer operators, there are no hidden charges, no cable fees, no bank commissions and no hefty foreign exchange markups.<br><br>
                                Check out the <a routerLink="/" style="cursor:pointer;">Fair Exchange Calculator</a> to find out the exact fee we charge and how much you save by transacting through us.
                            </p>
                          </div>
                      </div>
                  </div>

                  <div class="panel panel-default">
                      <div class="panel-heading">
                          <h4 class="panel-title">
                              <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse43">How do your charges compare with the banks? </a>
                          </h4>
                      </div>
                      <div id="collapse43" class="panel-collapse collapse">
                          <div class="panel-body">
                             <p>A bank levies a number of charges including foreign exchange mark-ups, cable charges,  commission and receiving bank charges.<br><br> 
                                Besides, if you are converting from one Asian currency to another Asian currency, the bank will first convert the Asian currency to US Dollar and levy a foreign exchange mark-up. They will then convert the US Dollar into the other Asian currency you wish to convert to and levy a second foreign exchange mark-up.<br><br>
                                So if you're comparing our transparent rate with that offered by your bank, make sure you add all these hidden charges.<br><br>
                                To quantify your savings potential, please refer to our <a routerLink="/" style="cursor:pointer;">Fair Exchange Calculator</a>.
                            </p>
                          </div>
                      </div>
                  </div>

                  
                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse44">How does your rate compare with Western Union or other money transfer operators?</a>
                        </h4>
                    </div>
                    <div id="collapse44" class="panel-collapse collapse">
                        <div class="panel-body">
                           <p>Western Union and other money transfer operators levy a fixed fee and a foreign exchange mark-up. A World Bank study shows that the average transaction fee charged by money transfer operators is 8% of the transaction amount. </p>
                        </div>
                    </div>
                  </div>


                  <!-- end remittance -->

                  <!-- create transfer request -->
                  <div class="faqHeader">Create A Transfer Request</div>
                  <div class="panel panel-default">
                      <div class="panel-heading">
                          <h4 class="panel-title">
                              <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse51">How do I pay for the transfer?</a>
                          </h4>
                      </div>
                      <div id="collapse51" class="panel-collapse collapse">
                          <div class="panel-body">
                            <p> Simply go to your bank's website, log into your Internet Banking service and make the transfer to our Singapore bank account. It is important that you enter the transaction reference number in the remarks or description field when sending the money through online banking. <br><Br>
                                If you are sending money from your DBS Bank account in Singapore, for example, follow these simple steps:
                            </p>
                            <ul class=" color_lightgrey paddingbullet" style="list-style: none;" >													
                                <li>
                                   <p>
                                    <b> Step 1: </b>
                                     Select 'To Other DBS or POSB Account' in the top menu after login.<br><br>
                                     <img src="/assets/images/saving_step1.jpg" >
                                   </p>
                                </li>
                                
                                    <li>
                                   <p>
                                    <b> Step 2: </b>
                                     After the authentication process, you will view the following screen. At this stage, you could click on 'Add New DBS or POSB Recipient' under 'More Options':<br><br>
                                     <img src="/assets/images/saving_step2.jpg" >
                                   </p>
                                </li>
                                
                                <li>
                                   <p>
                                    <b> Step 3: </b>
                                     This will take you to the screen below. Please enter the Recipient's Name as 'SingX Singapore Pte Ltd Client'. Even though the full name cannot be accommodated here, we will still receive your payment. Enter the account number as you see on your email with the subject 'Transfer Initiated'. Please enter your account name under 'My initials'. Then click Next. After the OTP verification, the account will get added as a recipient account. Then click on 'To Other DBS or POSB Account'.<br><br>
                                     <img src="/assets/images/saving_step3.jpg" >
                                   </p>
                                </li>
                                
                                <li>
                                   <p>
                                    <b> Step 4: </b>
                                    Create the transfer instruction. There is no place available to enter a reference number in DBS' user interface. This is fine, we can still identify your transaction based on your name. If you have made more than one transaction, please email us via <a href="mailto:help@singx.co">help&#64;singx.co</a> and let us know which transaction this is meant for.<br><br>
                                     <img src="/assets/images/saving_step4.jpg" >
                                   </p>
                                </li>
                                
                                                                        
                                </ul>
                          </div>
                      </div>
                  </div>
                  <div class="panel panel-default">
                      <div class="panel-heading">
                          <h4 class="panel-title">
                              <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse52">How can I schedule money transfers on a monthly or periodic basis? </a>
                          </h4>
                      </div>
                      <div id="collapse52" class="panel-collapse collapse">
                          <div class="panel-body">
                            <p> All the details of the receiver's bank account are stored (view under 'Manage my receivers'). So, if you wish to make repeat transfers to the same receiver, all you need to do is select an existing receiver. It's that simple. 
                                We cannot take standing instructions for recurring transfers though. You will have to create a new transaction each time. Simply check the exchange rate, confirm the transaction, select your bank account and the receiver's bank account, and you are on your way. Once we receive your money, we will execute your repeat payment.  
                          </div>
                      </div>
                  </div>

                  <div class="panel panel-default">
                      <div class="panel-heading">
                          <h4 class="panel-title">
                              <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse53">Can I add more than one of my bank accounts to my SingX account?</a>
                          </h4>
                      </div>
                      <div id="collapse53" class="panel-collapse collapse">
                          <div class="panel-body">
                             <p>Yes, you can add any number of your bank accounts to your SingX account. Remember that you can transfer money from a bank account only if you are the main or joint holder on that account.
                            </p>
                          </div>
                      </div>
                  </div>

                  
                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse54">Can I send money from my spouse's or family member's bank account to a receiver's account? </a>
                        </h4>
                    </div>
                    <div id="collapse54" class="panel-collapse collapse">
                        <div class="panel-body">
                           <p>You can only send money from an account where your name is on the bank account. So if you have a joint account with your spouse or a family member, then you may send money from that joint account. If, however, your name is not on the account, then you cannot send money from that bank account. <br>

                            Instead, please invite them to <a routerLink="/" style="cursor:pointer;">sign up</a> with us.</p>
                        </div>
                    </div>
                  </div>

                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse55">Can I transfer money from a joint bank account? </a>
                        </h4>
                    </div>
                    <div id="collapse55" class="panel-collapse collapse">
                        <div class="panel-body">
                           <p>Yes, you can transfer money from a joint account, if you are the main or second holder on that account.</p>
                        </div>
                    </div>
                  </div>

                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse55c">Can my receiver receive money in cash?</a>
                        </h4>
                    </div>
                    <div id="collapse55c" class="panel-collapse collapse">
                        <div class="panel-body">
                           <p>SingX offers cash pay-outs only in Philippines.</p>
                        </div>
                    </div>
                  </div>

                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse56c">Where can my recipient collect the funds in the Philippines?</a>
                        </h4>
                    </div>
                    <div id="collapse56c" class="panel-collapse collapse">
                        <div class="panel-body">
                           <p>You can choose any one of the following pay-out partners' locations in Philippines:</p>
                           <table id="customers">
                            <tbody><tr>
                              <th>No</th>
                              <th>Name</th>
                              <th>Website</th>
                            </tr>
                            <tr>
                            <td>1</td>
                            <td>BDO Cash Pickup</td>
                            <td><a href="https://www.bdo.com.ph/branches-atms-locator">https://www.bdo.com.ph/branches-atms-locator</a></td>
                            </tr>
                            <tr>
                            <td>2</td>
                            <td>M Lhuillier</td>
                            <td><a href="http://www.mlhuillier.com/branches/">http://www.mlhuillier.com/branches/</a></td>
                            </tr>
                            <tr>
                            <td>3</td>
                            <td>Cebuana Lhuillier</td>
                            <td><a href="https://www.cebuanalhuillier.com/">https://www.cebuanalhuillier.com/</a></td>
                            </tr>
                            <tr>
                            <td>4</td>
                            <td>Palawan Pawnshop</td>
                            <td><a href="http://www.palawanpawnshop.com/pera-padala">http://www.palawanpawnshop.com/pera-padala</a></td>
                            </tr>
                            <tr>
                            <td>5</td>
                            <td>LBC Express</td>
                            <td><a href="https://lbcexpress.com/">https://lbcexpress.com/</a></td>
                            </tr>
                            <tr>
                            <td>6</td>
                            <td>BPI</td>
                            <td><a href="https://secure1.bpiexpressonline.com/locator/search.aspx?loc=BRANCH">https://secure1.bpiexpressonline.com/locator/search.aspx?loc=BRANCH</a></td>
                            </tr>
                            <tr>
                            <td>7</td>
                            <td>Metrobank</td>
                            <td><a href="https://www.metrobank.com.ph/locate_branch.asp">https://www.metrobank.com.ph/locate_branch.asp</a></td>
                            </tr>
                            <tr style="display: none;">
                            <td>8</td>
                            <td>SM Counters</td>
                            <td><a href="https://www.bdo.com.ph/branches-atms-locator">https://www.bdo.com.ph/branches-atms-locator</a></td>
                            </tr>
                        </tbody>
                    </table>
                        </div>
                    </div>
                  </div>

                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse57c">When will funds be available for collection in the Philippines?</a>
                        </h4>
                    </div>
                    <div id="collapse57c" class="panel-collapse collapse">
                        <div class="panel-body">
                           <p>If you send money to us on a business day during business hours, the money will be available for pick-up in Philippines usually within 1-2 hours. If you have sent money to us after 4pm SGT, then its best that you ask the beneficiary to go to the pick-up location on the next business day. Sometimes  we may require further information from you before we can process the transfer in order to comply with our regulatory requirements. We will email you if this is the case.</p>
                        </div>
                    </div>
                  </div>

                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse58c">How long does the receiver have to pick up the cash?</a>
                        </h4>
                    </div>
                    <div id="collapse58c" class="panel-collapse collapse">
                        <div class="panel-body">
                           <p>Your receiver needs to pick up the cash within 28 working days.</p>
                        </div>
                    </div>
                  </div>

                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse59c">What information do I need from my recipient to pick up cash in the Philippines?</a>
                        </h4>
                    </div>
                    <div id="collapse59c" class="panel-collapse collapse">
                        <div class="panel-body">
                           <p>Your receiver needs to go in person to the pay-out partner's location. The receiver must carry a valid photo ID (Driver's license, passport, or any local government-issued photo ID, or a student ID). The receiver will also need to mention your (the sender's name), our service operators name (Tranglo), the transfer amount and a unique PIN that is sent to him via SMS. In the interest of safety, sometimes our pay-out partners may ask additional questions to establish the receiver's identity.</p>
                        </div>
                    </div>
                  </div>

                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse192">Will I get a FIRC for the money I transfer to India?</a>
                        </h4>
                    </div>
                    <div id="collapse192" class="panel-collapse collapse">
                        <div class="panel-body">
                            <p>Yes, your receiver can apply for a Foreign Inward Remittance Certificate (certificate of inward remittance) from his or her bank. Your beneficiary bank will contact our bank in India to confirm that the origin of the funds was indeed from outside of India.</p>
                            <p>Note that payments for the following purposes are only allowed through banking channels as per RBI guidelines:</p>
                            <ol class="color_lightgrey paddingbullet">
                                <li><p>Foreign Direct Investment (FDI)</p></li>
                                <li><p>Foreign Institutional Investment (FII)</p></li>
                            </ol>
                            <p>This means we can't complete transfers for FDI/FII on your behalf, so a FIRC can't be issued.</p>
                        </div>
                    </div>
                  </div>
                  <!-- end create transfer request -->
                  <!-- trubleshoot -->
                  <div class="faqHeader">Troubleshoot Active Transactions</div>
                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse61">My receiver has not received the money. What do I do?</a>
                        </h4>
                    </div>
                    <div id="collapse61" class="panel-collapse collapse">
                        <div class="panel-body">
                           <p> Once we have received your funds in our client account, the remittances to India are typically completed within 2 to 5 working hours. Remittances to Malaysia, Indonesia & Philippines are usually completed on the next working day,and remittance to Hong Kong usually take about 48 working hours from the time we receive your funds. </p>
                           <p>However, in some cases, it may take 1 to 3 working days depending on the efficiency of internet banking at your receiver's bank. Please check the status of your transaction on the Dashboard. If for any reason, we were unable to credit the receiver's account, you can track your refund there too. For further help, please email us at help&#64;singx.co.</p>
                            
                        </div>
                    </div>
                  </div>

                  
                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse62">Will my transaction expire? How long is my transaction valid?</a>
                        </h4>
                    </div>
                    <div id="collapse62" class="panel-collapse collapse">
                        <div class="panel-body">
                            <p>
                                Once you have confirmed a transaction, it is valid at that exchange rate for a fixed period. We must sight your funds in our bank account before the transaction expires. If we receive your money in our bank account after the transaction has expired, we will not be able to proceed with it. 
                                Validity Period Guidance for all currencies (in Singapore time): 
                            </p>
                            <ul class="regular10 color_lightgrey paddingbullet">
                                <li>Any transaction created between 12:00 am (midnight) and 5:00 pm will be valid until 5:00 pm the same day (including weekends and public holidays).</li>
                                <li>Any transaction created between 5:00 pm and 11:59 pm will be valid until 5:00 pm the next day (including weekends and public holidays).</li>				
                            </ul>	
                            
					<style>
                        table#customers {
                            font-size:15px;
                            border-collapse: collapse;
                            border-spacing: 0;
                            width: 70%;
                            border: 1px solid #f60;
                        }
                        
                        #customers td, #customers th {
                            border-bottom: 1px solid #f60;
                            padding: 8px;
                        }
                        
                        #customers tr:nth-child(even){background-color: #FFEAE7}
                        
                        #customers th {
                            padding-top: 11px;
                            padding-bottom: 11px;
                            background-color: #f60;
                            color: white;
                        }
                        
                        
                        </style>
                        	<table id="customers">
                                <tbody><tr>
                                  <th>Transaction Created On</th>
                                  <th>Transaction Valid Until</th>
                                  <th>Transaction Processed On**</th>
                                </tr>
                                <tr>
                                <td>Tuesday, 10am</td>
                                <td>Tuesday, 5pm</td>
                                <td>Tuesday</td>
                                </tr>
                                <tr class="alt">
                                <td>Tuesday, 6pm   </td>
                                <td>Wednesday, 5pm</td>
                                <td>Wednesday</td>
                                </tr>
                                <tr>
                                <td>Friday, 7pm* </td>
                                <td>Saturday, 5pm</td>
                                <td>Monday</td>
                                </tr>
                                <tr class="alt">
                                <td>Saturday, 10am* </td>
                                <td>Saturday, 5pm</td>
                                <td>Monday</td>
                                </tr>
                                
                                <tr>
                                  <td colspan="3" style="text-align:left;font-size:13px;">
                                   <b> <i>* The Status on your dashboard will remain unchanged till Monday.</i></b><br>
                                    <b><i>** The transaction will be processed subject to funds being received within transaction validity period.</i></b>
                                  </td>
                                </tr>
                                </tbody>
                            
                            </table>
                            <p>
					       Most local banks offer instant transfers (via FAST), however please be aware that these are not always instant, so we request you not to wait till the last moment to transfer your money. To ensure that money is sighted by us in our bank account well before the cut off, please send your funds as early as possible. 
					        </p>
                           <p>If you wish to transfer money after the validity period has passed (i.e. the transaction has expired), then you will need to initiate a new transaction. Please note that our exchange rates are live and are constantly changing, so the exchange rate on your new transaction may differ from the rate on your old transaction.</p>
				
                        </div>
                    </div>
                  </div>

                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse63">Will I get some sort of proof of the transaction?</a>
                        </h4>
                    </div>
                    <div id="collapse63" class="panel-collapse collapse">
                        <div class="panel-body">
                           <p>Absolutely. You can track the status of your transaction at any time on the Dashboard page. You can also print statements for completed transactions and receipts as PDFs for your own or receiver's reference.</p>
                         
                        </div>
                    </div>
                  </div>

                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse64">I forgot the reference number of my transaction. What do I do? </a>
                        </h4>
                    </div>
                    <div id="collapse64" class="panel-collapse collapse">
                        <div class="panel-body">
                           <p>After initiating the transaction, you will receive an email and SMS notification containing the reference number. Alternatively, you can login to your SingX dashboard and find the reference number under the recent transactions section.</p>
                         
                        </div>
                    </div>
                  </div>

                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse65">Why did my transaction fail? </a>
                        </h4>
                    </div>
                    <div id="collapse65" class="panel-collapse collapse">
                        <div class="panel-body">
                           <p>There are various reasons why a transaction may fail. For example, the receiver's name and account number provided by you may not match, or the receiver's account may be blocked or closed by his or her bank. You can view all your transactions on the 'Recent transactions' page. If a transaction has failed, we will tell you the reason next to it, as soon as we are given the reason from the receiver's bank.</p>
                         
                        </div>
                    </div>
                  </div>

                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse66">My transaction has failed. How do I get my money back? </a>
                        </h4>
                    </div>
                    <div id="collapse66" class="panel-collapse collapse">
                        <div class="panel-body">
                           <p>	Not to worry, we will send your money back to the same account from which you sent it to us. Some transaction charges may apply though. You can view all your transactions on the 'Recent transactions' page and the status of your refund will be updated against that transaction.</p>
                         
                        </div>
                    </div>
                  </div>

                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse67">What does 'validity' of a transaction mean?</a>
                        </h4>
                    </div>
                    <div id="collapse67" class="panel-collapse collapse">
                        <div class="panel-body">
                           <p>The exchange rate between currencies is constantly moving, but we allow you to 'lock in'  the exchange rate when you create a transaction on our website. The validity of this exchange rate is confirmed to you at the end of the transaction. You need to send the money to our bank account in Singapore before the end of this validity period to enjoy the confirmed rate. </p>
                         
                        </div>
                    </div>
                  </div>

                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse68">I have sent money to your account, but status still shows as 'Processing'. What does this mean?</a>
                        </h4>
                    </div>
                    <div id="collapse68" class="panel-collapse collapse">
                        <div class="panel-body">
                           <p>After you have sent money to our account, your transaction status will not change right away. This does not mean that your money hasn't been received. The transaction status will only change after the money is credited into your receiver's account. </p>
                         
                        </div>
                    </div>
                  </div>

                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse69">I raised a transaction on late Friday evening. When will the transaction get completed?</a>
                        </h4>
                    </div>
                    <div id="collapse69" class="panel-collapse collapse">
                        <div class="panel-body">
                           <p>	Transactions received on Friday evening will get processed over the weekend but may only be credited on the next working day, depending on the receiver bank. For more details on processing times,<a routerLink="/country-details">click here</a> </p>
                         
                        </div>
                    </div>
                  </div>

                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse70">How can I cancel my transaction?</a>
                        </h4>
                    </div>
                    <div id="collapse70" class="panel-collapse collapse">
                        <div class="panel-body">
                           <p>	Once a transaction has been created, it cannot be cancelled. If you do not wish to proceed with the transaction, do not transfer the funds to us for processing. However, please note that transactions which have already ​
                            been processed by SingX cannot be cancelled.  </p>
                         
                        </div>
                    </div>
                  </div>


                  <!-- end troubleshoot -->

                  <!-- payment -->
                  <div class="faqHeader">Payment</div>
                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse71">How do I pay by bank transfer?</a>
                        </h4>
                    </div>
                    <div id="collapse71" class="panel-collapse collapse">
                        <div class="panel-body">
                            <p><b>SingX Wallet</b></p>
                            <p>SingX now offers a wallet which can be used for remittances, overseas bill payments and global mobile top ups.<br>
                                To use this method, you will need to top up your wallet with funds first. There is a maximum limit of SGD5,000 that can be stored in your wallet at any given time.<br>
                                Once your wallet has funds, you can create a transaction and indicate your wallet as the selected payment method. This will auto-deduct the funds from your wallet balance and process your transaction instantly!
                            </p>
                              <p><b>Bank Transfer</b></p>
                                 <p>
                                     After you create a remittance transaction, we will show you the payment instructions. They will include:
                                 </p>
                            <ul>
                                <li>A unique transaction reference number</li>
                                <li>The amount you need to send</li>
                                <li>Our bank account details</li>
                            </ul>
                            <p>
                                You can make this transfer via online banking. Simply go to your bank's website, log into your Internet Banking service and make the transfer. It is important that you enter the transaction reference number in the remarks or description field when sending the money through online banking.
                            </p>
                        </div>
                    </div>
                  </div>

                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse72">Can I pay by cheque, cash or card?</a>
                        </h4>
                    </div>
                    <div id="collapse72" class="panel-collapse collapse">
                        <div class="panel-body">
                           <p>Sorry, we do not accept cheque or cash payment. As of now, we have not enabled payment by credit or debit card.  </p>
                        </div>
                    </div>
                  </div>

                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse73">What about joint bank accounts? </a>
                        </h4>
                    </div>
                    <div id="collapse73" class="panel-collapse collapse">
                        <div class="panel-body">
                           <p>Yes, you can transfer money from a joint account, if you are the main or second holder on that account.</p>
                         
                        </div>
                    </div>
                  </div>

                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse74">What is the unique transaction number?</a>
                        </h4>
                    </div>
                    <div id="collapse74" class="panel-collapse collapse">
                        <div class="panel-body">
                            <p>After you create a transaction, we will show you the payment instructions. They will include:</p>
                            <ul>
                            <li>A unique transaction reference number</li>
                            <li>The amount you need to send</li>
                            <li>Our bank account details</li>
                            </ul>
                            <p>The unique transaction number is used to uniquely identify your transaction and to track its status. </p>
                            <p>  After completing the transaction, you will also receive an email and SMS notification containing the unique transaction reference number.</p>
                           
                        </div>
                    </div>
                  </div>

                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse75">In my bank's screen for making an online payment, there is no place to put in a Transaction Reference Number. What do I do?</a>
                        </h4>
                    </div>
                    <div id="collapse75" class="panel-collapse collapse">
                        <div class="panel-body">
                           <p>	If you are unable to provide us the Transaction Reference Number as part of your bank transfer, that's okay. We can still match your payment to your transaction based on your name & account number. However, please ensure that you have cancelled all other valid transactions of the same amount before making the bank transfer to us. If there are multiple transactions of the same amount, SingX reserves the right to fulfil any one of the valid transactions that you have created. Please note that transactions which have already expired or which have been processed by SingX cannot be cancelled.</p>
                        </div>
                    </div>
                  </div>

                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse76">I have created two transactions, but a bank transfer for one of them. How do I let you know which transaction I want to proceed with?</a>
                        </h4>
                    </div>
                    <div id="collapse76" class="panel-collapse collapse">
                        <div class="panel-body">
                            <p> If you want to ensure we fulfil a specific transaction, please create only one transaction at a time. If you create multiple transactions of the same amount, SingX reserves the right to process any of these transactions at its discretion.</p>
                            
                        </div>
                    </div>
                  </div>
                  <!-- end payment -->

                  <!-- wallet -->
                  <div class="faqHeader">SingX Wallet</div>
                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse121">How do I top up my wallet balance</a>
                        </h4>
                    </div>
                    <div id="collapse121" class="panel-collapse collapse">
                        <div class="panel-body">
                           <p> Currently we offer wallet top-ups via PayNow or online banking transfers
                            All you have to do is:</p>
                            <ol>
                                <li>Login to your SingX account</li>
                                <li>Click on 'Top Up' wallet</li>
                                <li>Enter the top-up amount and select PayNow or Bank Transfer</li>
                                <li>Login to your internet banking portal and send us the funds via PayNow or Bank Transfer</li>
                            </ol>
                        </div>
                    </div>
                  </div>

                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse122">Is there a top up limit</a>
                        </h4>
                    </div>
                    <div id="collapse122" class="panel-collapse collapse">
                        <div class="panel-body">
                           <p>Yes, the wallet limit is capped at SGD 20,000. </p>
                        </div>
                    </div>
                  </div>

                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse123">Why should I use the SingX wallet?</a>
                        </h4>
                    </div>
                    <div id="collapse123" class="panel-collapse collapse">
                        <div class="panel-body">
                           <p> For one, you don't have to worry about sending funds to us for every transaction. Once you top up your SingX wallet, we can simply deduct the cash for your transfer from the balance! So all you'll have to do is book a transaction, we'll handle the rest!<br><br>
                            In addition, sending money using your wallet will enable us to process your transactions even faster!</p>
                         
                        </div>
                    </div>
                  </div>

                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse124">Are there any additional charges when I pay with the wallet?</a>
                        </h4>
                    </div>
                    <div id="collapse124" class="panel-collapse collapse">
                        <div class="panel-body">
                            <p>  No, there are no additional fees involved.</p>
                        </div>
                    </div>
                  </div>

                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse125">Is there a limit to the number of transactions that I can make with my Wallet?</a>
                        </h4>
                    </div>
                    <div id="collapse125" class="panel-collapse collapse">
                        <div class="panel-body">
                           <p>  No, there is no limit to the number of transactions that you can make, as long as there is sufficient balance in your Wallet. </p>
                        </div>
                    </div>
                  </div>

                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse126">Will the top-up be instantaneous?</a>
                        </h4>
                    </div>
                    <div id="collapse126" class="panel-collapse collapse">
                        <div class="panel-body">
                            <p>Top-ups to the Wallet can take 1-4 hrs, once it is successful the new balance will be reflected on your SingX dashboard. </p>
                            
                        </div>
                    </div>
                  </div>

                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse127">Can I refund the remaining value in my Wallet?</a>
                        </h4>
                    </div>
                    <div id="collapse127" class="panel-collapse collapse">
                        <div class="panel-body">
                            <p>Yes, the balance amount in your Wallet can be refunded upon request via <a href="mailto:help@singx.co">help&#64;singx.co</a> However, there will be a small charge imposed for initiating a refund. </p> 
                            
                        </div>
                    </div>
                  </div>
                  <!-- end wallet -->

                  <!-- Billpay FAQs -->
                  <!-- <div class="faqHeader">Bill Payments (India)</div>
                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse211">How To Pay Bills in India Online</a>
                        </h4>
                    </div>
                    <div id="collapse211" class="panel-collapse collapse">
                        <div class="panel-body">
                            <P>Paying bills is now a seamless and quick process online. You can make this payment instantly in a few simple steps:</P>
                            <ul>
                            <li>Login to SingX and Go to 'Bill Payments(India)' section</li>
                            <li>Select your Billing Category and the respective operator from the dropdown</li>
                            <li>Type in your consumer details and click on 'Proceed'</li>
                            <li>Your bill details will appear on the screen</li>
                            <li>Simply click to make the payment' via your SingX Wallet (auto-deduction)</li>
                            </ul>
                        </div>
                    </div>
                  </div>

                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse212">What payment options are available to make Bill Payments on SingX?</a>
                        </h4>
                    </div>
                    <div id="collapse212" class="panel-collapse collapse">
                        <div class="panel-body">
                            <P>At SingX, we offer customers a wallet which can be topped up using PayNow or Bank Transfer. You can pay your bills using this wallet – we'll auto-deduct the amount for you!</P>
                        </div>
                    </div>
                  </div>
                  <-- DTH -->
                  <!-- <div class="faqHeader">DTH</div>
                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse314">How long does it take to process DTH Recharge Online?</a>
                        </h4>
                    </div>
                    <div id="collapse314" class="panel-collapse collapse">
                        <div class="panel-body">
                            <P>When you recharge DTH connection, the transaction gets completed within a few minutes and depending upon the processes of respecting operator, the recharged balance will reflect in your DTH account.</P>
                        </div>
                    </div>
                  </div>

                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse312">Does SingX support all operators for DTH recharge plans?</a>
                        </h4>
                    </div>
                    <div id="collapse312" class="panel-collapse collapse">
                        <div class="panel-body">
                            <P>You can make online DTH recharge across various operators such as<span style="color: blue;"> Airtel DTH, Dish TV Recharge, Tata Sky Recharge, Videocon D2H and Sun Direct Recharge.</span> </P>
                        </div>
                    </div>
                  </div>

                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse313">How to check DTH balance online?</a>
                        </h4>
                    </div>
                    <div id="collapse313" class="panel-collapse collapse">
                        <div class="panel-body">
                            <P>The process of checking the DTH balance varies from operator to operator. The balance can be checked either online or on the operators' website or by contacting (SMS/ Call) the customer support number.</P>
                        </div>
                    </div>
                  </div>
                  <div class="faqHeader">Electricity</div>
                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse315">Which operators are available for Electricity Bill Payments?</a>
                        </h4>
                    </div>
                    <div id="collapse315" class="panel-collapse collapse">
                        <div class="panel-body">
                            <P>You can make online electricity bill payment via SingX across various operators such as UPPCL,TNEB,WBSEDCL,JVVNL,NBPDCL,PSPCL,SBPDCL,DHBVN,APDCL,BESCOM,UHBVN,APEPDCL,APSPDCL,CESC,UGVCL,DGVCL,CSEB,HESCOM, <br>PGVCL,APEPDCL,BSES Rajdhani,BSES Yamuna and many more.</P>
                        </div>
                    </div>
                  </div>
                  <div class="faqHeader heading">BroadBand</div>
                  <P>Broadband is high speed internet connection enabled through different mediums. Broadband bill payment can be easily done online in an instant. Online broadband bill payment ensures instant bill payment and uninterrupted internet services.</P>
                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse316">How long does it take to process the Broadband Bill Payment?</a>
                        </h4>
                    </div>
                    <div id="collapse316" class="panel-collapse collapse">
                        <div class="panel-body">
                            <P>Payments are instant and easy. Once a user confirms the broadband bill payment, it is instantly reflected in their account. Processing by different broadband operators may vary.</P>
                        </div>
                    </div>
                  </div>

                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse317">Does SingX support all operators for Broadband Bill Payment?</a>
                        </h4>
                    </div>
                    <div id="collapse317" class="panel-collapse collapse">
                        <div class="panel-body">
                            <P>SingX allows users to make the online broadband bill payment across a wide range of operators including ACT Fibernet, Airtel, ASIANET, BSNL, Comway, Connect, DEN, ION and many more.</P>
                        </div>
                    </div>
                  </div>

                  <div class="faqHeader">Credit Cards</div>
                  <p>Credit card allows users to avail short term credit from their banks for immediate payments. For credit card users it is very important to remember the credit card bill date. The user shall clear the dues monthly. If users don't make their Credit Card Payment on time, they are charged with interest. Further, untimely payment of the credit card bill also leads to late fee. In order to avoid unnecessary late fees and interest on credit card processing, users can instantly make their online credit card payment using SingX.</p>
		
                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse318">For Visa, SingX allows Credit Card Payment of all banks. For any other, bill payment of only the following cards can be made.</a>
                        </h4>
                    </div>
                    <div id="collapse318" class="panel-collapse collapse">
                        <div class="panel-body">
                            <ul>
                                <li>American Express</li>
                                <li>Andhra Bank</li>
                                <li>Axis Bank</li>
                                <li>Bank Of Baroda</li>
                                <li>Canara Bank</li>
                                <li>CITI Bank  </li>
                                <li>City Union Bank  </li>
                                <li>HDFC Bank Ltd  </li>
                                <li>ICICI Bank Ltd  </li>
                                <li>IDBI Ltd</li>
                                <li>Indusland Bank Ltd  </li>
                                <li>Ratnakar Bank Ltd (RBL)  </li>
                                <li>Standard Chartered Bank Ltd</li>
                                <li>State Bank Of India  </li>
                                <li>Syndicate Bank  </li>
                                <li>United Bank Of India  </li>
                                <li>Yes Bank  </li>
                                
                            </ul>
                        </div>
                    </div>
                  </div>

                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse319">Can I only pay the minimum due amount?  </a>
                        </h4>
                    </div>
                    <div id="collapse319" class="panel-collapse collapse">
                        <div class="panel-body">
                            <P>You can pay the minimum due amount. But if done on a regular basis, it can adversely affect your Credit Score.</P>
                        </div>
                    </div>
                  </div>

                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse320">Do I need to pay my credit card in full? </a>
                        </h4>
                    </div>
                    <div id="collapse320" class="panel-collapse collapse">
                        <div class="panel-body">
                            <P>Ideally you should pay your credit card bill in full but if you cannot do that, try to keep the balance as low as possible. Lower the balance, better for your credit score.</P>
                        </div>
                    </div>
                  </div>

                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse321">When should I pay my credit card bill?   </a>
                        </h4>
                    </div>
                    <div id="collapse321" class="panel-collapse collapse">
                        <div class="panel-body">
                            <P>You should pay your credit card bill before the due date to avoid extra late fee charges.</P>
                        </div>
                    </div>
                  </div>

                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse323">Does late payment affect my credit Score?</a>
                        </h4>
                    </div>
                    <div id="collapse323" class="panel-collapse collapse">
                        <div class="panel-body">
                            <P>Yes, late payments do affect your credit score. Whether you are thirty days late or three days late, a history of late repayment suggests that you are an unreliable borrower.</P>
                        </div>
                    </div>
                  </div>

                  <div class="faqHeader heading">Cable</div>
                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse324">Cable connection usually needs monthly cable bill payment to ensure seamless cable connectivity.</a>
                        </h4>
                    </div>
                    <div id="collapse324" class="panel-collapse collapse">
                        <div class="panel-body">
                            <P>There are many companies which offer cable connection across the country like Hathway Cable, InCable, Reliance Digital TV, HiFi Vision, Digi Cable, etc. As the times change, even the cable operators have turned towards online payment modes instead of the conventional billing system. The conventional billing system required either the customers to visit the cable office to make the bill payments or the cable operator to come and collect the monthly bill. However, despite the facility to pay cable bill online, most cable TV subscribers still prefer to pay the cable bill through conventional means. The problem is that the payment portals to pay cable bill online are quite complex to navigate through. However, to solve this problem, SingX has integrated the payment portals of multiple cable operators within its portal. Now, you can easily and conveniently make the cable TV online payment using SingX. </P>
                        </div>
                    </div>
                  </div> -->
                      <!-- end Billpay FAQs -->
                <!-- Global Mobile Topups FAQs -->
                <!-- <div class="faqHeader">Global Mobile Top Ups</div>
                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse411">What can I do with this service?</a>
                        </h4>
                    </div>
                    <div id="collapse411" class="panel-collapse collapse">
                        <div class="panel-body">
                            <P>You can send prepaid mobile credit to your friends and family. Simply select the country, enter the mobile phone number to top-up, choose the plan, enter your payment details and you're all set! </P>
                        </div>
                    </div>
                  </div>

                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse412">What countries does SingX serve? </a>
                        </h4>
                    </div>
                    <div id="collapse412" class="panel-collapse collapse">
                        <div class="panel-body">
                            <P>You can Top up mobiles in India, Malaysia, Philippines and Indonesia.</P>
                        </div>
                    </div>
                  </div>

                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse413">What is top up?</a>
                        </h4>
                    </div>
                    <div id="collapse413" class="panel-collapse collapse">
                        <div class="panel-body">
                            <P>Top up is the Airtime, Data or bundle pack that you can load on a mobile phone number.</P>
                        </div>
                    </div>
                  </div>

                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse414">How do I send a Top up? </a>
                        </h4>
                    </div>
                    <div id="collapse414" class="panel-collapse collapse">
                        <div class="panel-body">
                            <P>If you are an existing SingX remittance user,</P>
                            <ul>
                                <li>Login to your dashboard. </li>
                                <li>Click Global Mobile Top ups.  </li>
                                <li>Select the Country. </li>
                                <li>Enter the Mobile Number. </li>
                                <li>Select the Operator. </li>
                                <li>Select the Top Up Plan (Airtime, Data or Bundle). </li>
                                <li>Review the order and complete payment using our secure online payment process. </li>
                                <li>A confirmation message will appear on your screen with details on your completed transaction. </li>
                                <li>A confirmation SMS will be sent to your mobile number.</li>
                            </ul>
                            <p>NOTE: Recipients will also receive a transaction confirmation SMS message from their Mobile operator. </p>
                        </div>
                    </div>
                  </div>
                  
                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse415">Do I have to create an account to use this service? </a>
                        </h4>
                    </div>
                    <div id="collapse415" class="panel-collapse collapse">
                        <div class="panel-body">
                            <P>In order to access this service, you need to be a fully registered SingX customer. </P>
                        </div>
                    </div>
                  </div>

                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse418">Why I am receiving am OTP? </a>
                        </h4>
                    </div>
                    <div id="collapse418" class="panel-collapse collapse">
                        <div class="panel-body">
                            <P>You are receiving am OTP so that we can make sure this is your mobile phone number and prevent fraud. </P>
                        </div>
                    </div>
                  </div>

                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse419">Do I have to log in to my account each time I want to send credit? </a>
                        </h4>
                    </div>
                    <div id="collapse419" class="panel-collapse collapse">
                        <div class="panel-body">
                            <P>Yes, each time you wish to top up, you will need to log in to your account. This is meant for security purposes. This will enable you to facilitate your transaction in case you stored or debit/credit card information. </P>
                        </div>
                    </div>
                  </div>

                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse420">Can I send top-up/credit to any mobile number?  </a>
                        </h4>
                    </div>
                    <div id="collapse420" class="panel-collapse collapse">
                        <div class="panel-body">
                            <P>Phone number needs to belong to one of the countries we serve and correspond to a prepaid account. </P>
                        </div>
                    </div>
                  </div>

                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse421">What will happen if I try to top-up a phone number that is not supported? </a>
                        </h4>
                    </div>
                    <div id="collapse421" class="panel-collapse collapse">
                        <div class="panel-body">
                            <P>Don't worry, in this case the service will alert you and tell you we cannot send credit to this mobile phone. </P>
                        </div>
                    </div>
                  </div>

                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse422">How much top up amount can I send? </a>
                        </h4>
                    </div>
                    <div id="collapse422" class="panel-collapse collapse">
                        <div class="panel-body">
                            <P>Once you enter the mobile number you want to send credit to, you will be prompted to choose between different plans (Airtime, Data, Bundles). The plans depend on the mobile operator attached to the mobile number you're topping up.  </P>
                        </div>
                    </div>
                  </div>

                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse423">How can I know if the top up has been received by the recipient? </a>
                        </h4>
                    </div>
                    <div id="collapse423" class="panel-collapse collapse">
                        <div class="panel-body">
                            <P>You will receive an SMS. The recipient will also receive an SMS detailing the amount/plan credited to his/her mobile number.</P>
                        </div>
                    </div>
                  </div>

                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse424">I received a confirmation SMS, but my contact says he/she hasn't received the credit </a>
                        </h4>
                    </div>
                    <div id="collapse424" class="panel-collapse collapse">
                        <div class="panel-body">
                            <P>In this case, first make sure you topped up to the correct mobile number. If you are sure, please contact our customer service at <a href="mailTo:help@singx.co " style="color: blue;">help&#64;singx.co </a></P>
                        </div>
                    </div>
                  </div>

                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse425">How much time does it take for the top up to show up on my contact's account? </a>
                        </h4>
                    </div>
                    <div id="collapse425" class="panel-collapse collapse">
                        <div class="panel-body">
                            <P>The top up is sent right away to your recipient. Recipient will receive a confirmation SMS. </P>
                        </div>
                    </div>
                  </div>

                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse426">I sent credit to a wrong number by mistake, can I cancel the transaction? </a>
                        </h4>
                    </div>
                    <div id="collapse426" class="panel-collapse collapse">
                        <div class="panel-body">
                            <P>Unfortunately, the credit is sent right away to the mobile phone number you provided, and therefore a completed transaction may not be cancelled. This is why we show you several times during the top-up process the mobile number you're sending to, in order for you to double-check. Therefore, our policy in this case is to not reimburse the transaction. </P>
                        </div>
                    </div>
                  </div>

                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse427">What are the different payment means available? </a>
                        </h4>
                    </div>
                    <div id="collapse427" class="panel-collapse collapse">
                        <div class="panel-body">
                            <P>You can pay using the SingX Wallet which can be topped up using PayNow or Bank Transfer. </P>
                        </div>
                    </div>
                  </div>

                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse428">How can I be sure the transfer has been successful? </a>
                        </h4>
                    </div>
                    <div id="collapse428" class="panel-collapse collapse">
                        <div class="panel-body">
                            <P>You will receive a confirmation on the web interface, on your mobile. The recipient will also receive a confirmation on his mobile phone </P>
                        </div>
                    </div>
                  </div>

                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse430">Can I send Top up to more than one mobile number? </a>
                        </h4>
                    </div>
                    <div id="collapse430" class="panel-collapse collapse">
                        <div class="panel-body">
                            <P>Yes, you can send mobile<span style="color: blue;"> Top Up </span> to more than one mobile number. </P>
                        </div>
                    </div>
                  </div>

                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse431">What is the cost to send a Top up? </a>
                        </h4>
                    </div>
                    <div id="collapse431" class="panel-collapse collapse">
                        <div class="panel-body">
                            <P>The cost of a Top Up transaction is based upon the denomination amount selected. During the checkout process, the total amount payable will be indicated. This amount includes the details of any additional charges (such as taxes or SMS fees) that affect the ultimate Top Up recharge amount that will be received by the transaction recipient. </P>
                        </div>
                    </div>
                  </div>

                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse432">What happens if my SingX Wallet is charged and I do not receive the Top up?</a>
                        </h4>
                    </div>
                    <div id="collapse432" class="panel-collapse collapse">
                        <div class="panel-body">
                            <P>Please contact our support team immediately at <a href="mailto:help@singx.co" style="color: blue;">help&#64;singx.co </a></P>
                        </div>
                    </div>
                  </div>

                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse434">What is the exchange rate while conducting a mobile top up transactions? </a>
                        </h4>
                    </div>
                    <div id="collapse434" class="panel-collapse collapse">
                        <div class="panel-body">
                            <P>SingX utilizes the fairest exchange rate available, in keeping with international Foreign Exchange regulations and agreement with our partners. Exchange rates are subject to change and fluctuation on a daily basis. </P>
                        </div>
                    </div>
                  </div>  -->
                <!-- End Global Mobile Topups FAQs -->
                <div class="faqHeader">Account Management</div>
                <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse81">How do I edit profile details?</a>
                        </h4>
                    </div>
                    <div id="collapse81" class="panel-collapse collapse">
                        <div class="panel-body">
                            <P>Please log in and you will see your Dashboard. Click on your name on the top right and select 'Profile' from the drop-down menu. Make the necessary changes to your personal profile details and save the changes.</P>
                        </div>
                    </div>
                </div>

                <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse82">How do I change my password?</a>
                        </h4>
                    </div>
                    <div id="collapse82" class="panel-collapse collapse">
                        <div class="panel-body">
                        <p>Please log in and you will see your Dashboard. Click on your name on the top right and select 'Change Password' from the drop-down menu. Make the necessary changes and save.<br><br>
                            If you forget your username/password or are unable to sign in, click on “Forgot password?” link on the login page. 
                            Our password policy is as follows:</p> 
                            <ul>
                                <li>Minimum 8 alphanumeric characters password.</li>
                                <li>At least one letter in uppercase.</li>
                                <li>Must not repeat any letter or number.</li>
                            </ul>	
                        </div>
                    </div>
                </div>

                <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse83">How do I change my email address?</a>
                        </h4>
                    </div>
                    <div id="collapse83" class="panel-collapse collapse">
                        <div class="panel-body">
                        <p>	To change your email address, please write to us at <a href="mailto:help@singx.co">help&#64;singx.co</a></p>	
                        </div>
                    </div>
                </div>

                <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse84">How do I change my mobile number?</a>
                        </h4>
                    </div>
                    <div id="collapse84" class="panel-collapse collapse">
                        <div class="panel-body">
                        <p>To change your mobile number, please write to us at <a href="mailto:help@singx.co">help&#64;singx.co</a></p>	
                        </div>
                    </div>
                </div>

                <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse85">How do I add/delete my receiver's bank account?</a>
                        </h4>
                    </div>
                    <div id="collapse85" class="panel-collapse collapse">
                        <div class="panel-body">
                            <b>Add an account</b> <br>
                            <ul>
                            <li>After you log into your account, you will find 'Manage Receivers' link on your dashboard.</li>
                            <li>To add a new receiver: Click on the '+Add' button and enter all the relevant information for the bank account you wish to send money to, and click Save. To confirm the new account, a One-Time Password (OTP) authentication is required. You will receive an OTP on your registered mobile number. Enter the OTP exactly as received and click confirm. Once validated, you will see the confirmation/summary for the bank account you have entered. You can select the receiver's bank from the dropdown list. </li>
                            </ul>
                              <b>Delete an account</b> <br>
                            <ul>
                            <li>To delete an existing receiver bank account: select the respective receiver's bank account and click 'De-activate'. Click 'Confirm' and the selected receiver's bank record will be listed as inactive. </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse86">How do I add/delete my (sender) bank account?</a>
                        </h4>
                    </div>
                    <div id="collapse86" class="panel-collapse collapse">
                        <div class="panel-body">
                            <b>Add an account</b> <br>				
                            <ul>
                            <li>After you log into your account, you will find 'Manage my bank accounts' link on your dashboard. </li>
                            <li>To add new bank details: Click on '+ Add', and enter your new bank details. You can search for your bank by entering the bank name. Click 'Add sender' after all information has been completed. You will now see the new bank details listed on the 'My bank accounts' page.</li>
                            </ul>
                             <b>Delete an account</b> <br>	
                            <ul>
                            <li>To delete an existing sender bank account: Click on 'Delete' against the respective bank account details. Click 'Confirm' and the selected bank account will be removed from the list.</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse87">What details do I need to add a receiver's account?</a>
                        </h4>
                    </div>
                    <div id="collapse87" class="panel-collapse collapse">
                        <div class="panel-body">
                            <p> <b>Add an account</b> </p> 		
                            <p> Please ensure you ask the receiver for (i) the receiver's name (ii) receiver's account number and (iii) the receiver's bank name. In addition:</p> 
                                <ul>
                                <li>If you are sending money to India, you will also require the IFSC code and the receiver's address.</li>
                                <li>If you are sending money to Malaysia, you will also require the receiver's nationality, address & contact number, receiver type (whether an individual or business), and if a business then business registration ID.</li>
                                <li>If you are sending money to Hong Kong, you will require the Bank and Branch Code for your Receiver's bank account. These are three digit codes based on the Hong Kong Interbank Clearing System and if unsure, your Receiver can check for the bank clearing code and branch code here: <a href="http://www.hkicl.com.hk/clientbrowse.do?docID=7259" target="_blank" >http://www.hkicl.com.hk/clientbrowse.do?docID=7259</a></li>
                                </ul>
                        </div>
                    </div>
                </div>

                <div class="faqHeader">Technical & Browser Queries</div>
                <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse91">What Internet browsers do you support?</a>
                        </h4>
                    </div>
                    <div id="collapse91" class="panel-collapse collapse">
                        <div class="panel-body">
                            <p>	Our website is optimised for Safari (version 8 and above) and Google Chrome (Version 43 and above).</p>
                        </div>
                    </div>
                </div>

                <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse92">How do I enable cookies?</a>
                        </h4>
                    </div>
                    <div id="collapse92" class="panel-collapse collapse">
                        <div class="panel-body">
                            <b>Google Chrome:</b>
                            <ul>
                            <li>Select 'Settings' from browser menu list.</li>
                            <li>Select 'Show advanced settings...' at the bottom of the page.</li>
                            <li>Under the heading 'Privacy', select 'Content Settings'.</li>
                            <li>Under the heading 'Cookies', select 'Allow local data to be set' and make sure 'Block third-party cookies and site data' is unticked.</li>
                            <li>Click 'Done' in the bottom right-hand corner of the popup window.</li>
                            </ul>
        
                            <b>Safari:</b>
                            <ul>
                            <li>Select 'Safari', next to the Apple logo.</li>
                            <li>Select 'Preferences...', from the drop down menu.</li>
                            <li>Select 'Privacy' in the popup window.</li>
                            <li>In the category 'Cookies and website data', select 'Allow from websites I visit'.</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse93">How do I clear my cache?</a>
                        </h4>
                    </div>
                    <div id="collapse93" class="panel-collapse collapse">
                        <div class="panel-body">
                           <p><b>Google Chrome:</b></p> 
                             <p>Select 'Preference' from browser menu list.</p> 
                            <p>Select 'Show advanced settings...' at bottom of the page.</p>
                            <p>Under the heading 'Privacy', select 'Clear browsing data...'.</p>
                            <p>At the top of the popup window, next to 'Obliterate the following items from:' select your desired duration to clear. (Recommended to be at least 'the last 4 weeks'.)</p>
                            <p>Tick 'Cached images and files'.</p>
                            <p>Click 'Clear browsing data'.</p>
                           
                            <p><b>Safari:</b></p>
                            <p>Select 'Safari', next to the Apple logo.</p>
                            <p>Select 'Preferences...', from drop-down menu.</p>
                            <p>Select the furthest right tab 'Advanced' in popup window.</p>
                            <p>At the bottom of the 'Advanced' window, you should see the option 'Show Develop menu in menu bar'. Tick this.</p>
                            <p>Close popup window.</p>
                            <p>Top of the screen, click on 'Develop' between 'Bookmarks' and 'Window'.</p>
                            <p>In the drop-down menu, click on 'Empty Caches'.</p>
                           
                        </div>
                    </div>
                </div>

                <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse94">How do I take a screenshot?</a>
                        </h4>
                    </div>
                    <div id="collapse94" class="panel-collapse collapse">
                        <div class="panel-body">
                                <p>For Apple MacBook, press command + shift + 3 buttons and screenshot image will be saved on your desktop.</p>
                                <p>For Windows, press Print Screen key and paste to image editor to save the screenshot.</p>
                                <p>For iPhone or iPad, hold down home + lock buttons and screenshot will be saved into camera roll.</p>
                                <p>For Android, please refer to the brand and model manual.</p>
                            
                        </div>
                    </div>
                </div>

                <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse95">Which Internet browser works best for SingX?</a>
                        </h4>
                    </div>
                    <div id="collapse95" class="panel-collapse collapse">
                        <div class="panel-body">
                            <p>Our website is optimised for Safari (version 8 and above) and Google Chrome (Version 43 and above).</p>
                            <p> It is essential to make sure your Internet browser is up-to-date for best user experience and security. Using an outdated browser may pose data security threat.</p>
                           
                        </div>
                    </div>
                </div>

                <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse101">Is my personal data safe?</a>
                        </h4>
                    </div>
                    <div id="collapse101" class="panel-collapse collapse">
                        <div class="panel-body">
                            <p>We take the safety of your personal details very seriously. To facilitate secure data transmission over the Internet, we have all the  <span nz-tooltip
                                nzTooltipTitle="System integrity and the confidentiality of your personal and transaction details are our top priority. For data to be transmitted securely over the Internet, we use Secure Socket Layer (SSL), 128-bit encryption within the logged-in site pages. To check if your connection is secure, just look for the https url and the secure padlock symbol at the bottom right of your browser window or in the address bar.All data is held on secure servers hosted by Data Electronics (ISO 9001:2008 and ISO 27001 certified) along with a managed firewall service as well as guaranteed power and connectivity to provide the highest levels of security 24/7." style="color: blue;"> safety precautions</span> in place We have adopted a 
                                <span nz-tooltip
                                nzTooltipTitle="Two-factor authentication improves account security by combining what you know, e.g. 
                                your password, with something that only you possess, such as your mobile phone. When
                                 trying to log in or carry out certain actions, such as transferring money, we will automatically 
                                 send a One-time Password (OTP) to your phone. Enter the OTP into the two-factor authentication form on our site and you can transact with total 
                                 peace of mind after that" style="color: blue;">two-step authentication process</span> 
                                 which ensures complete security and peace of mind. We also ensure that our website keeps your <span nz-tooltip
                                 nzTooltipTitle="Our website uses 256-bit encryption via Secure Socket Layer (SSL) from VeriSign. This means that your connection is secure." style="color: blue;">connection secure</span>  All your account information is stored in a secure facility that is safeguarded by us. </p>
                        </div>
                    </div>
                </div>

                <!-- end global faqs -->
                	<!-- currency alert start here -->
                    <div class="faqHeader">Rate Alert</div>
                    <div class="panel panel-default">
                        <div class="panel-heading">
                            <h4 class="panel-title">
                                <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse111">Do I need to register with SingX to create a rate alert?</a>
                            </h4>
                        </div>
                        <div id="collapse111" class="panel-collapse collapse">
                            <div class="panel-body">
                                <p class=" regular10 color_lightgrey">No, you do not need to register with SingX to subscribe for our rate alerts. However certain features are only available to registered users, hence for full access we recommend that you create an account. Registration is free and easy, click <a routerLink="/" >here</a> to sign up now. </p>
                            </div>
                        </div>
                    </div>

                    <div class="panel panel-default">
                        <div class="panel-heading">
                            <h4 class="panel-title">
                                <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse112">Does it cost me anything to setup a rate alert?</a>
                            </h4>
                        </div>
                        <div id="collapse112" class="panel-collapse collapse">
                            <div class="panel-body">
                                <p class=" regular10 color_lightgrey">No, setting up rate alerts with SingX is free of charge for all users. We aim to keep you updated with our live exchange rates so that you can transact at the rates you want!. </p>
                            </div>
                        </div>
                    </div>

                    <div class="panel panel-default">
                        <div class="panel-heading">
                            <h4 class="panel-title">
                                <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse113">What are the different types of rate alert that SingX offers?</a>
                            </h4>
                        </div>
                        <div id="collapse113" class="panel-collapse collapse">
                            <div class="panel-body">
                                <ul>
                                    <li>Rate reaches your desired value: Alert if the rate of the currency pair selected reaches your specified value 
                                    </li>
                                    <li>Rate is at its Two-weeks high:  Alert if the rate of the currency pair selected is the highest in the past two weeks </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div class="panel panel-default">
                        <div class="panel-heading">
                            <h4 class="panel-title">
                                <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse114">Can I set multiple rate alerts for the same currency pair? (i.e. Three different rate alerts for SGD to INR)</a>
                            </h4>
                        </div>
                        <div id="collapse114" class="panel-collapse collapse">
                            <div class="panel-body">
                                <p>At this time, you can only set one rate alert for each currency pair. However, you can have both types of rate alert set up for the same currency pair. The two types of alert offered on SingX are: a) Rate reaches your desired value b) Rate is at its Two-weeks high. You may edit this rate alert by logging in to your SingX account and selecting Rate Alerts > Manage Alerts.</p>
					
                            </div>
                        </div>
                    </div>

                    <div class="panel panel-default">
                        <div class="panel-heading">
                            <h4 class="panel-title">
                                <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse115">Can I receive the same rate alert via both SMS and Email?</a>
                            </h4>
                        </div>
                        <div id="collapse115" class="panel-collapse collapse">
                            <div class="panel-body">
                                <p>This option is available for all registered users of SingX. If you wish to receive the same type of rate alert via both Email and SMS, then please select "Both" option in the channel of communication.</p>
					
                            </div>
                        </div>
                    </div>

                    <div class="panel panel-default">
                        <div class="panel-heading">
                            <h4 class="panel-title">
                                <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse116">Does the foreign exchange rate involve any markups?</a>
                            </h4>
                        </div>
                        <div id="collapse116" class="panel-collapse collapse">
                            <div class="panel-body">
                                <p >Absolutely not. SingX provides 100% transparency with no hidden fees or foreign exchange markups. The  rate alert that you receive is for the live, mid-market exchange rate. </p>
					
                            </div>
                        </div>
                    </div>

                    <div class="panel panel-default">
                        <div class="panel-heading">
                            <h4 class="panel-title">
                                <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse117">Will you hold the foreign exchange rate that I receive via the rate alert email/SMS notification for me to transact at?</a>
                            </h4>
                        </div>
                        <div id="collapse117" class="panel-collapse collapse">
                            <div class="panel-body">
                               
					      <p >Unfortunately, no. SingX provides live foreign exchange rates that are always fluctuating. Hence, we are unable to hold a specific rate indicated in the rate alert for customers. If you would like to enjoy the FX rate indicated in the rate alert, please log on to the SingX portal and book a transaction as soon as possible. After this, you will need to transfer the funds to SingX as indicated on the transaction page. </p>
					
                            </div>
                        </div>
                    </div>

                    <div class="panel panel-default">
                        <div class="panel-heading">
                            <h4 class="panel-title">
                                <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse118">How many times will I receive alerts if the foreign exchange rate exceeds the limit that I set? (i.e. I set up an alert if 1 SGD crosses 46 INR)</a>
                            </h4>
                        </div>
                        <div id="collapse118" class="panel-collapse collapse">
                            <div class="panel-body">
                                <p>We will send you rate alerts five times if the rate crosses your set limit. For example, if you set a rate alert of 1 SGD to go above 46 INR, the rate alert notification will be sent 5 times (1 per day) when the rate goes above 46. After receiving the alert 5 times, you will then receive an email notification to set a new rate alert if you wish to continue receiving the alerts.</p>
					
                            </div>
                        </div>
                    </div>

                    <div class="panel panel-default">
                        <div class="panel-heading">
                            <h4 class="panel-title">
                                <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse119">How does a two-week high alert work?</a>
                            </h4>
                        </div>
                        <div id="collapse119" class="panel-collapse collapse">
                            <div class="panel-body">
                                <p>If the rate for your currency pair is the highest in the past two weeks, you will receive a rate alert. For example, if you set a two-week high rate alert for SGD to MYR, you will receive an alert if this condition is met. The two-week high rate alerts will be sent 5 times, after which you will receive an email notification to set a new rate alert if you wish to continue receiving the alerts.  </p>
					
                            </div>
                        </div>
                    </div>

                    <div class="panel panel-default">
                        <div class="panel-heading">
                            <h4 class="panel-title">
                                <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse1110">How can I edit my existing alerts?</a>
                            </h4>
                        </div>
                        <div id="collapse1110" class="panel-collapse collapse">
                            <div class="panel-body">
                                <ul>
                                    <li>
                                      If you are a registered user with SingX: log in to your account, click on your profile, select Rate Alerts-> Manage Alerts. You can edit your existing alert by clicking on the edit icon shown at the end.
                                    </li>
                                      <li>If you are not a registered user with SingX, you are unable to edit your alert. However,  you can delete the alert by using the unsubscribe link in the rate alert email and then create a new one. </li>
                                      </ul>	
                            </div>
                        </div>
                    </div>

                    <div class="panel panel-default">
                        <div class="panel-heading">
                            <h4 class="panel-title">
                                <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse1111">How many times will I receive rate alerts in one day?</a>
                            </h4>
                        </div>
                        <div id="collapse1111" class="panel-collapse collapse">
                            <div class="panel-body">
                                <p>You will receive one rate alert every 24 hours.</p>
					
                            </div>
                        </div>
                    </div>

                    <div class="panel panel-default">
                        <div class="panel-heading">
                            <h4 class="panel-title">
                                <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse1112">How do I unsubscribe from the rate alerts?</a>
                            </h4>
                        </div>
                        <div id="collapse1112" class="panel-collapse collapse">
                            <div class="panel-body">
                            
                                    <ul>
                                      <li>If you are a registered user with SingX: log in to your account, click on your profile, select Rate Alerts-> Manage Alerts and simply delete the alerts you would like to unsubscribe from </li>
                                      <li>If you are not a registered user with SingX, simply click on the unsubscribe link in the SingX rate alert emails you have reeived.</li>
                                      </ul>
                            </div>
                        </div>
                    </div>

                    <div class="panel panel-default">
                        <div class="panel-heading">
                            <h4 class="panel-title">
                                <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse1113">Can I share the rate alert with my friends?</a>
                            </h4>
                        </div>
                        <div id="collapse1113" class="panel-collapse collapse">
                            <div class="panel-body">
                            
                                <p>Absolutely! Feel free to share this rate with your friends on social media or via email to help them enjoy unbeatable exchange rates with SingX.</p>
					
					
                            </div>
                        </div>
                    </div>

                    <div class="panel panel-default">
                        <div class="panel-heading">
                            <h4 class="panel-title">
                                <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse1114">Who can I contact if I still have questions?</a>
                            </h4>
                        </div>
                        <div id="collapse1114" class="panel-collapse collapse">
                            <div class="panel-body">
                                <p>No problem. Contact our helpful customer service team at +65 3158 4669 so they can guide you through the process of setting up rate alerts on our website. Alternatively, you may email us with your questions at help&#64;singx.co</p>
					
					
                            </div>
                        </div>
                    </div>

                    <!-- currency alert end here -->

                </div>
            </div>
            <!--end container -->
        </div>
        <!--end services-wrapper -->
    </section>
    
    <!-- Bootstrap FAQ - END -->

    <!-- FAQs For HK -->
    <section *ngIf="country == 'hk'">
        <!--begin services-wrapper -->
        <div class="services-wrapper">
            <!--begin container -->
            <div class="container">
                <br />
                <br />
                <br />
            
            
                <br />
            
                <div class="panel-group FAQ" id="accordion"> 
                <div>
                    <h1 style="font-size: 34px; color: #FF6600; font-weight: 500;">Frequently Asked Questions (FAQs)</h1>
                 </div>
                    <div class="faqHeader">General</div>
                    <div class="panel panel-default">
                        <div class="panel-heading">
                            <h4 class="panel-title">
                                <a class="accordion-toggle" data-toggle="collapse" data-parent="#accordion" href="#collapseOne">1. Am I eligible to sign up?</a>
                            </h4>
                        </div>
                        <div id="collapseOne" class="panel-collapse collapse in">
                            <div class="panel-body">
                                <p> If you are a resident of Hong Kong, you can sign up with us. It's simple and free, so <a href="javascript:void(0)" (click)="redirectToRegistrationPage()" style="cursor:pointer; color: blue;">start now.</a></p>
                            </div>
                        </div>
                    </div>
                    <div class="panel panel-default">
                        <div class="panel-heading">
                            <h4 class="panel-title">
                                <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapseTen">2. How long does it take?</a>
                            </h4>
                        </div>
                        <div id="collapseTen" class="panel-collapse collapse">
                            <div class="panel-body">
                                <p> You can send money to more than 30 countries. Please <a routerLink="/country-details" style="cursor:pointer; color: blue;">click here</a> to view details.</p>
                               
                            </div>
                        </div>
                    </div>
                    <div class="panel panel-default">
                        <div class="panel-heading">
                            <h4 class="panel-title">
                                <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapseEleven">3. How much does it cost?</a>
                            </h4>
                        </div>
                        <div id="collapseEleven" class="panel-collapse collapse">
                            <div class="panel-body">
                                <p>
                                    We charge a small fee, between 0.25% and 1% of the <span nz-tooltip
                                    nzTooltipTitle="The mid-market rate is the rate with no exchange mark-up. This is the rate at which the big banks trade money with each other, and it is the rate you will find on independent sources such as Google or XE.com. In short, it is the best exchange rate you can get at any point of time." style="color: blue;">mid-market rate</span>  For stable and frequently traded currencies the fee is closer to 0.5%, and for more volatile and less frequently traded currencies the fee is higher (up to 1%). Check out the <a routerLink="/"  style="cursor:pointer; color: blue;">Fair Exchange Calculator</a> to find out the exact fee we charge and how much you save by transacting through us. 
                                    Our charges are fully transparent so that there are no surprises. Unlike banks or other money transfer operators, there are no hidden charges, no cable fees, no bank commissions, and no hefty foreign exchange mark-ups.
                                </p>
                            
                            </div>
                        </div>
                    </div>

                    <div class="panel panel-default">
                        <div class="panel-heading">
                            <h4 class="panel-title">
                                <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapsetwelve">4. How long does it take?</a>
                            </h4>
                        </div>
                        <div id="collapsetwelve" class="panel-collapse collapse">
                            <div class="panel-body">
                                <p>
                                    After we have received your money, it will typically take us a few hours to credit your nominated receiver's bank account in most cases. However, it will vary depending on the receiver country and banks, for more details on processing times, please <a routerLink="/country-details" style="color: blue;"> click here</a>.
                                </p>
                                
                            </div>
                        </div>
                    </div>

                    <div class="panel panel-default">
                        <div class="panel-heading">
                            <h4 class="panel-title">
                                <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapsethirteen">5. Is my money safe?</a>
                            </h4>
                        </div>
                        <div id="collapsethirteen" class="panel-collapse collapse">
                            <div class="panel-body">
                                <p> The safety of your money is as important to us, as it is to you. Your money is safe with us for 4 reasons:</p>
                                <ol>
                                    <li><p><b>Your funds are kept in a segregated client account.</b><br>As a regulated payment services provider, we must hold all money transferred by our clients in segregated bank accounts. These accounts are separate from our own bank accounts. So, your money is never mixed with ours, and we cannot use your money to settle any of our own obligations.</p></li>
                                    <li><p><b>We have a credible and trustworthy team.</b><br>
                                    The Shareholders and Directors of SingX are professionals who have worked with reputed multinational banks throughout their careers. They operate with the highest levels of integrity. Click <a routerLink="/team" style="color: blue;">here</a> to read about the profiles of our key management.</p></li>
                                    <li>
                                        <p><b>We work with Licensed Remittance Operators (LROs) in each country. </b><br>
						
                                        These LROs are licensed to do remittance transactions by the Central Bank in their respective countries. Click <a routerLink="/licenses">here</a>
                                        for more details on the licensed entities we deal with.
                                    </li>
                                    <li>
                                        <p><b>We implement a host of security measures, just like the banks.</b><br>
                                            We take the safety of your personal details very seriously. To facilitate secure data transmission over the Internet, we have all the
                                               <span nz-tooltip
                                               nzTooltipTitle="System integrity and the confidentiality of your personal and transaction details are our top priority.
                                               For data to be transmitted securely over the Internet, we use Secure Socket Layer (SSL), 128-bit encryption within the logged-in site pages. To check if your connection is secure, just look for the https url and the secure padlock symbol at the bottom right of your browser window or in the address bar.
                                               All data is held on secure servers hosted by Data Electronics (ISO 9001:2008 and ISO 27001 certified) along with a managed firewall service as well as guaranteed power and connectivity to provide the highest levels of security 24/7." style="color: blue;">safety precautions</span> 
                                          in place. We have adopted a <span nz-tooltip
                                          nzTooltipTitle=" Two-factor authentication improves account security by combining what you know, e.g. your password, with something that only you possess, such as your mobile phone. When trying to log in or carry out certain actions, such as transferring money, we will automatically send a One-time Password (OTP) to your phone. Enter the OTP into the two-factor authentication form on our site and you can transact with total peace of mind after that." style="color: blue;">two-step authentication process</span> which ensures complete security and peace of mind. We also ensure that our website keeps your <span nz-tooltip
                                          nzTooltipTitle=" Our website uses 256-bit encryption via Secure Socket Layer (SSL) from VeriSign. This means that your connection is secure." style="color: blue;">connection secure</span> All your account information is stored in a secure facility that is safeguarded by us. </p>
                        
                                </ol>
                            </div>
                        </div>
                    </div>
                    
                    <div class="panel panel-default">
                        <div class="panel-heading">
                            <h4 class="panel-title">
                                <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapsefourteen">6. How do I sign up?</a>
                            </h4>
                        </div>
                        <div id="collapsefourteen" class="panel-collapse collapse">
                            <div class="panel-body">
                                <ol class=" color_lightgrey paddingbullet" style="list-style-type: none;" >
										
                                    <li><p><b>Step 1: Click here to get started.</b><br>If you are a resident of Singapore, you can sign up with us. It's simple and free. <a href="javascript:void(0)" (click)="redirectToRegistrationPage()" style="cursor:pointer;">Start now</a>.</p></li>
                                    <li><p><b>Step 2: Complete your registration online.</b><br> 
                                        SingX is governed by the same regulations as your bank. Provide the required information online, enter an OTP (one-time password) sent to your mobile and upload a photo or scanned copy of your identification documents.
                                        For businesses, please write to us at
                                         <a rouuterLink="mailto:help.hk@singx.co" style="text-decoration: underline; color: blue;">help.hk&#64;singx.co</a>
                                         and we will take you through the sign-up process.
                                         <br><br>
                                         Once we have received your application, we'll need approximately 1 working day to activate your account.</p>
                                        </li>
                                    
                                </ol>
                            </div>
                        </div>
                    </div>
            
                    <div class="panel panel-default">
                        <div class="panel-heading">
                            <h4 class="panel-title">
                                <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapsefifteen">7. How do I make a transaction?</a>
                            </h4>
                        </div>
                        <div id="collapsefifteen" class="panel-collapse collapse">
                            <div class="panel-body">
                                <p>Before you start a transaction, make sure that you have completed the <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapsefourteen">sign up process</a> and received an email from us confirming that your account is ready.</p>
                                <ol class=" color_lightgrey paddingbullet" >
                                        <ul class="regular10 color_lightgrey paddingbullet">
                                            <li><p>1) Use our Fair Exchange Calculator to check the savings you can enjoy.</p></li>
                                            <p>Choose the currencies you wish to transfer from and to, as well as the amount you wish to send. Get an estimate of the incredible savings you enjoy.
                                            </p>
                                            <p>
                                              2) With a few simple clicks, confirm the transaction and then transfer the money. Follow these simple steps to confirm your transaction:
                                            </p>
                                        </ul>
                                    <ul class="regular10 color_lightgrey paddingbullet">
                                        <li><p>Click 'Start Your Transfer' to confirm that you want to transfer money.</p></li>
                                        <li><p>Confirm the amount and currency.</p></li>
                                        <li><p>Enter the receiver's details or select from your favourites.</p></li>
                                        <li><p>Next, simply transfer the amount you are sending plus the SingX fee from your local bank account to our local bank account in Hong Kong using Internet Banking.
                                        </p></li>
                                    </ul>
                                    <ul class="regular10 color_lightgrey paddingbullet">
                                        <li><p>3) Sit back, relax and we'll take care of the rest.</p></li>
                                        <li><p>Say goodbye to hidden charges, cable fees, bank commissions and hefty foreign exchange mark-ups. We convert your money and deposit it in your receiver's bank account. You will be notified via email and SMS upon successful transfer.</p></li>
                                        
                                    </ul>

                                    </ol>
                            </div>
                        </div>
                    </div>

                    <div class="panel panel-default">
                        <div class="panel-heading">
                            <h4 class="panel-title">
                                <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapsesixteen">8. How much can I send?</a>
                            </h4>
                        </div>
                        <div id="collapsesixteen" class="panel-collapse collapse">
                            <div class="panel-body">
                                <p>You may transfer up to HKD 5.5 million. However, please note that there are some restrictions imposed by countries to which you are sending money to. View transactions limit by countries by  <a routerLink="/country-details" style="color: blue;"> clicking here.</a></p>
                            </div>
                        </div>
                    </div>

                    <div class="panel panel-default">
                        <div class="panel-heading">
                            <h4 class="panel-title">
                                <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapseseventeen">9. How can I contact SingX?</a>
                            </h4>
                        </div>
                        <div id="collapseseventeen" class="panel-collapse collapse">
                            <div class="panel-body">
                                Should you require assistance of any kind, you can email our Customer Care at <a href="mailto:help.hk@singx.co" >help.hk&#64;singx.co</a> You can contact our customer service agents via our 'Live Chat' between 9 am to 6 pm (Monday to Friday), or leave an offline message via the chat outside these operating hours.
                            </div>
                        </div>
                    </div>

                    <div class="faqHeader">Basic Information</div>
                    <div class="panel panel-default">
                        <div class="panel-heading">
                            <h4 class="panel-title">
                                <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapseTwo">Why should I use SingX?</a>
                            </h4>
                        </div>
                        <div id="collapseTwo" class="panel-collapse collapse">
                            <div class="panel-body">
                                <p>Here are 3 compelling reasons why you should use SingX for cross-border money transfers and international payments:</p>
                                <ol class=" color_lightgrey paddingbullet"  >
                                                                
                                <li><p><b>Enjoy great savings </b><br>You save up to 8% of the transaction amount every time you transfer money through us. Banks and other operators will usually charge you a hefty mark-up on the foreign exchange rate and have layers of hidden fees like cable charges and commission. SingX only charges a single small transparent fee.</p></li>
                                <li><p><b>Enjoy speedy transfers </b><br>After we have received your money, it will take us between 1 and 3 working days to credit your nominated receiver's bank account, depending on the speed of Internet Banking transfers in the receiver's country. For more details on processing times, please <a routerLink="/country-details" style="color: blue;">click here</a>.  
                                </li>
                                <li><p><b>Enjoy the online convenience </b><br>Say goodbye to filling in complicated wire transfer forms, signing and delivering original documents to your bank branch only to learn that you have filled the form incorrectly. With us, it's way simpler. Your information is stored with us. You simply confirm that you are happy with the exchange rate and then transfer money to us online.</p></li>
                                                                    
                                </ol>
                            </div>
                        </div>
                    </div>
                    <div class="panel panel-default">
                        <div class="panel-heading">
                            <h4 class="panel-title">
                                <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapseThree">Which countries can I transfer money from?</a>
                            </h4>
                        </div>
                        <div id="collapseThree" class="panel-collapse collapse">
                            <div class="panel-body">
                                <p>Currently, we offer transfers from Singapore, Australia and Hong Kong.</p>
                            </div>
                        </div>
                    </div>
            
                    <div class="faqHeader">Signing Up</div>
                    <div class="panel panel-default">
                        <div class="panel-heading">
                            <h4 class="panel-title">
                                <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapseFour">What is the registration process?</a>
                            </h4>
                        </div>
                        <div id="collapseFour" class="panel-collapse collapse">
                            <div class="panel-body">
                                <ol class=" color_lightgrey paddingbullet" style="list-style-type: none;" >
										
                                    <li><p><b>Step 1: <a style="cursor:pointer;" href="javascript:void(0)" (click)="redirectToRegistrationPage()">Click here</a> to get started.</b><br>
                                    </p></li>
                                    <li><p><b>Step 2: Complete your registration online.</b><br>SingX is governed by the same regulations as your bank. Provide the required information online, enter an OTP (one-time password) sent to your mobile and upload a photo or scanned copy of your identification documents.</p></li><br>
                                 
                                    <li>For businesses, please write to us at <a href="mailto:help.hk@singx.co">help.hk&#64;singx.co</a> and we will take you through the sign-up process.</li><br>
                                    <p>Once we have received your application, we'll need approximately 1 working day to activate your account.</p>
                                    
                                </ol>
                            </div>
                        </div>
                    </div>
                    <div class="panel panel-default">
                        <div class="panel-heading">
                            <h4 class="panel-title">
                                <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapseSeven">What documents are required? </a>
                            </h4>
                        </div>
                        <div id="collapseSeven" class="panel-collapse collapse">
                            <div class="panel-body">
                                <p>We only need a soft copy of your Hong Kong identification (ID) and some general information as part of the sign up process.</p>
                                  <p>For business users, please write to us at <a href="mailto:help.hk@singx.co">help.hk&#64;singx.co</a> and we will take you through the sign-up process.</p>
                            </div>
                        </div>
                    </div>

                    <div class="panel panel-default">
                        <div class="panel-heading">
                            <h4 class="panel-title">
                                <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapseeight">Does it cost anything to register with SingX?</a>
                            </h4>
                        </div>
                        <div id="collapseeight" class="panel-collapse collapse">
                            <div class="panel-body">
                                <p>Signing up with us is absolutely free!</p>
                            </div>
                        </div>
                    </div>

                 

                  <!-- remittance -->
                  <div class="faqHeader">Rates, Charges & Savings</div>
                  <div class="panel panel-default">
                      <div class="panel-heading">
                          <h4 class="panel-title">
                              <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse41">What are the real savings?</a>
                          </h4>
                      </div>
                      <div id="collapse41" class="panel-collapse collapse">
                          <div class="panel-body">
                            <p> You will save a lot of money. How much you save will vary, depending on the amount you transfer and the currencies involved. To calculate the savings on a transaction you may be considering, check out our <a routerLink="/" style="cursor:pointer;">Fair Exchange Calculator</a>. <br><br>
                                We constantly compare our fee to that of banks, remittance agents, card companies and others. These operators usually charge you a hefty mark-up on the foreign exchange rate and have layers of hidden fees like cable fees and commissions.<br><br>
                                We save you money by using the mid-market rate. This is the wholesale rate at which the big banks transact with each other. While other retail players apply a 'mark-up' on this rate, we offer the wholesale mid-market rate. We charge a small transparent fee which is shown to you upfront.<br><br>
                                Still not sure? Feel free to compare our rates with those offered by other providers.	
                            </p>
                          </div>
                      </div>
                  </div>
                  <div class="panel panel-default">
                      <div class="panel-heading">
                          <h4 class="panel-title">
                              <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse42">Will I be charged any fees/charges other than what I see in the Fair Exchange Calculator?</a>
                          </h4>
                      </div>
                      <div id="collapse42" class="panel-collapse collapse">
                          <div class="panel-body">
                            <p>Absolutely not. Our changes are fully transparent so there are no surprises. Unlike banks or other money transfer operators, there are no hidden charges, no cable fees, no bank commissions and no hefty foreign exchange markups.<br><br>
                                Check out the <a routerLink="/" style="cursor:pointer;">Fair Exchange Calculator</a> to find out the exact fee we charge and how much you save by transacting through us.
                            </p>
                          </div>
                      </div>
                  </div>

                  <div class="panel panel-default">
                      <div class="panel-heading">
                          <h4 class="panel-title">
                              <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse43">How do your charges compare with the banks? </a>
                          </h4>
                      </div>
                      <div id="collapse43" class="panel-collapse collapse">
                          <div class="panel-body">
                             <p>A bank levies a number of charges including foreign exchange mark-ups, cable charges, commission and receiving bank charges.<br><br> 
                                Besides, if you are converting from one Asian currency to another Asian currency, the bank will first convert the Asian currency to US Dollar and levy a foreign exchange mark-up. They will then convert the US Dollar into the other Asian currency you wish to convert to and levy a second foreign exchange mark-up.<br><br>
                                So if you're comparing our transparent rate with that offered by your bank, make sure you add all these hidden charges.<br><br>
                                To quantify your savings potential, please refer to our <a routerLink="/" style="cursor:pointer;">Fair Exchange Calculator</a>.
                            </p>
                          </div>
                      </div>
                  </div>

                  
                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse44">How does your rate compare with Western Union or other money transfer operators?</a>
                        </h4>
                    </div>
                    <div id="collapse44" class="panel-collapse collapse">
                        <div class="panel-body">
                           <p>Western Union and other money transfer operators levy a fixed fee and a foreign exchange mark-up. A World Bank study shows that the average transaction fee charged by money transfer operators is 8% of the transaction amount.</p>
                        </div>
                    </div>
                  </div>


                  <!-- end remittance -->

                  <!-- create transfer request -->
                  <div class="faqHeader">Create A Transfer Request</div>
                  <div class="panel panel-default">
                      <div class="panel-heading">
                          <h4 class="panel-title">
                              <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse51">How do I pay for the transfer?</a>
                          </h4>
                      </div>
                      <div id="collapse51" class="panel-collapse collapse">
                          <div class="panel-body">
                            <p>Simply go to your bank's website, log into your Internet Banking service and make the transfer to our Singapore bank account. It is important that you enter the transaction reference number in the remarks or description field when sending the money through online banking.

                            </p>
                          </div>
                      </div>
                  </div>
                  <div class="panel panel-default">
                      <div class="panel-heading">
                          <h4 class="panel-title">
                              <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse52">How can I schedule money transfers on a monthly or periodic basis? </a>
                          </h4>
                      </div>
                      <div id="collapse52" class="panel-collapse collapse">
                          <div class="panel-body">
                            <p> All the details of the receiver's bank account are stored (view under 'Manage my receivers').  So, if you wish to make repeat transfers to the same receiver, all you need to do is select an existing receiver. It’s that simple.

                                We cannot take standing instructions for recurring transfers though. You will have to create a new transaction each time. Simply check the exchange rate, confirm the transaction, select your bank account and the receiver's bank account, and you are on your way. Once we receive your money, we will execute your repeat payment.
                          </div>
                      </div>
                  </div>

                  <div class="panel panel-default">
                      <div class="panel-heading">
                          <h4 class="panel-title">
                              <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse53">Can I add more than one of my bank accounts to my SingX account?</a>
                          </h4>
                      </div>
                      <div id="collapse53" class="panel-collapse collapse">
                          <div class="panel-body">
                             <p>Yes, you can add any number of your bank accounts to your SingX account. Remember that you can transfer money from a bank account only if you are the main or joint holder on that account.
                            </p>
                          </div>
                      </div>
                  </div>

                  
                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse54">Can I send money from my spouse's or family member's bank account to a receiver's account? </a>
                        </h4>
                    </div>
                    <div id="collapse54" class="panel-collapse collapse">
                        <div class="panel-body">
                           <p>You can only send money from an account where your name is on the bank account. So if you have a joint account with your spouse or a family member, then you may send money from that joint account. If, however, your name is not on the account, then you cannot send money from that bank account. <br>

                            Instead, please invite them to <a href="javascript:void(0)" (click)="redirectToRegistrationPage()" style="cursor:pointer;">sign up</a> with us.</p>
                        </div>
                    </div>
                  </div>

                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse55">Can I transfer money from a joint bank account? </a>
                        </h4>
                    </div>
                    <div id="collapse55" class="panel-collapse collapse">
                        <div class="panel-body">
                           <p>Yes, you can transfer money from a joint account, if you are the main or second holder on that account.</p>
                        </div>
                    </div>
                  </div>

                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse55c">Can my receiver receive money in cash?</a>
                        </h4>
                    </div>
                    <div id="collapse55c" class="panel-collapse collapse">
                        <div class="panel-body">
                           <p>SingX offers cash pay-outs only in Philippines.</p>
                        </div>
                    </div>
                  </div>

                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse56c">Where can my recipient collect the funds in the Philippines?</a>
                        </h4>
                    </div>
                    <div id="collapse56c" class="panel-collapse collapse">
                        <div class="panel-body">
                           <p>You can choose any one of the following pay-out partners' locations in Philippines:</p>
                           <table id="customers">
                            <tbody><tr>
                              <th>No</th>
                              <th>Name</th>
                              <th>Website</th>
                            </tr>
                            <tr>
                            <td>1</td>
                            <td>BDO Cash Pickup</td>
                            <td><a href="https://www.bdo.com.ph/branches-atms-locator">https://www.bdo.com.ph/branches-atms-locator</a></td>
                            </tr>
                            <tr>
                            <td>2</td>
                            <td>M Lhuillier</td>
                            <td><a href="http://www.mlhuillier.com/branches/">http://www.mlhuillier.com/branches/</a></td>
                            </tr>
                            <tr>
                            <td>3</td>
                            <td>Cebuana Lhuillier</td>
                            <td><a href="https://www.cebuanalhuillier.com/">https://www.cebuanalhuillier.com/</a></td>
                            </tr>
                            <tr>
                            <td>4</td>
                            <td>Palawan Pawnshop</td>
                            <td><a href="http://www.palawanpawnshop.com/pera-padala">http://www.palawanpawnshop.com/pera-padala</a></td>
                            </tr>
                            <tr>
                            <td>5</td>
                            <td>LBC Express</td>
                            <td><a href="https://lbcexpress.com/">https://lbcexpress.com/</a></td>
                            </tr>
                            <tr>
                            <td>6</td>
                            <td>BPI</td>
                            <td><a href="https://secure1.bpiexpressonline.com/locator/search.aspx?loc=BRANCH">https://secure1.bpiexpressonline.com/locator/search.aspx?loc=BRANCH</a></td>
                            </tr>
                            <tr>
                            <td>7</td>
                            <td>Metrobank</td>
                            <td><a href="https://www.metrobank.com.ph/locate_branch.asp">https://www.metrobank.com.ph/locate_branch.asp</a></td>
                            </tr>
                            <tr style="display: none;">
                            <td>8</td>
                            <td>SM Counters</td>
                            <td><a href="https://www.bdo.com.ph/branches-atms-locator">https://www.bdo.com.ph/branches-atms-locator</a></td>
                            </tr>
                        </tbody>
                    </table>
                        </div>
                    </div>
                  </div>

                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse57c">When will funds be available for collection in the Philippines?</a>
                        </h4>
                    </div>
                    <div id="collapse57c" class="panel-collapse collapse">
                        <div class="panel-body">
                           <p>If you send money to us on a business day during business hours, the money will be available for pick-up in Philippines usually within 1-2 hours. If you have sent money to us after 4pm SGT, then its best that you ask the beneficiary to go to the pick-up location on the next business day. Sometimes we may require further information from you before we can process the transfer in order to comply with our regulatory requirements. We will email you if this is the case.</p>
                        </div>
                    </div>
                  </div>

                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse58c">How long does the receiver have to pick up the cash?</a>
                        </h4>
                    </div>
                    <div id="collapse58c" class="panel-collapse collapse">
                        <div class="panel-body">
                           <p>Your receiver needs to pick up the cash within 28 working days.</p>
                        </div>
                    </div>
                  </div>

                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse59c">What information do I need from my recipient to pick up cash in the Philippines?</a>
                        </h4>
                    </div>
                    <div id="collapse59c" class="panel-collapse collapse">
                        <div class="panel-body">
                           <p>Your receiver needs to go in person to the pay-out partner's location. The receiver must carry a valid photo ID (Driver's license, passport, or any local government-issued photo ID, or a student ID). The receiver will also need to mention your (the sender's name), our service operators name (Tranglo), the transfer amount and a unique PIN that is sent to him via SMS. In the interest of safety, sometimes our pay-out partners may ask additional questions to establish the receiver's identity.</p>
                        </div>
                    </div>
                  </div>

                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse192">Will I get a FIRC for the money I transfer to India?</a>
                        </h4>
                    </div>
                    <div id="collapse192" class="panel-collapse collapse">
                        <div class="panel-body">
                            <p>Yes, your receiver can apply for a Foreign Inward Remittance Certificate (certificate of inward remittance) from his or her bank. Your beneficiary bank will contact our bank in India to confirm that the origin of the funds was indeed from outside of India.</p>
                            <p>Note that payments for the following purposes are only allowed through banking channels as per RBI guidelines:</p>
                            <ol class="color_lightgrey paddingbullet">
                                <li><p>Foreign Direct Investment (FDI)</p></li>
                                <li><p>Foreign Institutional Investment (FII)</p></li>
                            </ol>
                            <p>This means we can't complete transfers for FDI/FII on your behalf, so a FIRC can't be issued.</p>
                        </div>
                    </div>
                  </div>
                  <!-- end create transfer request -->
                  <!-- trubleshoot -->
                  <div class="faqHeader">Troubleshoot Active Transactions</div>
                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse61">My receiver has not received the money. What do I do?</a>
                        </h4>
                    </div>
                    <div id="collapse61" class="panel-collapse collapse">
                        <div class="panel-body">
                           <p>Once we have received your funds in our client account, the remittances to India are typically completed within 2 to 5 working hours. Remittances to other corridors are typically the next working day.</p>
                           <p>However, in some cases, it may take 1 to 3 working days depending on the efficiency of internet banking at your receiver's bank. Please check the status of your transaction on the Dashboard. If for any reason, we were unable to credit the receiver's account, you can track your refund there too. For further help, please email us at help.hk&#64;singx.co.</p>
                            
                        </div>
                    </div>
                  </div>

                  
                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse62">Will my transaction expire? How long is my transaction valid?</a>
                        </h4>
                    </div>
                    <div id="collapse62" class="panel-collapse collapse">
                        <div class="panel-body">
                            <p>
                                Once you have confirmed a transaction, it is valid at that exchange rate for a fixed period. We must sight your funds in our bank account before the transaction expires. If we receive your money in our bank account after the transaction has expired, we will not be able to proceed with it.
                                Validity Period Guidance for all currencies (in Hong Kong time):
                            </p>
                            <ul class="regular10 color_lightgrey paddingbullet">
                                <li>Any transaction created between 12:00 am (midnight) and 5:00 pm will be valid until 5:00 pm the same day (including weekends and public holidays).</li>
                                <li>Any transaction created between 5:00 pm and 11:59 pm will be valid until 5:00 pm the next day (including weekends and public holidays).</li>				
                            </ul>	
                            
					<style>
                        table#customers {
                            font-size:15px;
                            border-collapse: collapse;
                            border-spacing: 0;
                            width: 70%;
                            border: 1px solid #f60;
                        }
                        
                        #customers td, #customers th {
                            border-bottom: 1px solid #f60;
                            padding: 8px;
                        }
                        
                        #customers tr:nth-child(even){background-color: #FFEAE7}
                        
                        #customers th {
                            padding-top: 11px;
                            padding-bottom: 11px;
                            background-color: #f60;
                            color: white;
                        }
                        
                        
                        </style>
                        	<table id="customers">
                                <tbody><tr>
                                  <th>Transaction Created On</th>
                                  <th>Transaction Valid Until</th>
                                  <th>Transaction Processed On**</th>
                                </tr>
                                <tr>
                                <td>Tuesday, 10am</td>
                                <td>Tuesday, 5pm</td>
                                <td>Tuesday</td>
                                </tr>
                                <tr class="alt">
                                <td>Tuesday, 6pm   </td>
                                <td>Wednesday, 5pm</td>
                                <td>Wednesday</td>
                                </tr>
                                <tr>
                                <td>Friday, 7pm* </td>
                                <td>Saturday, 5pm</td>
                                <td>Monday</td>
                                </tr>
                                <tr class="alt">
                                <td>Saturday, 10am* </td>
                                <td>Saturday, 5pm</td>
                                <td>Monday</td>
                                </tr>
                                
                                <tr>
                                  <td colspan="3" style="text-align:left;font-size:13px;">
                                   <b> <i>* The Status on your dashboard will remain unchanged till Monday.</i></b><br>
                                    <b><i>** The transaction will be processed subject to funds being received within transaction validity period.</i></b>
                                  </td>
                                </tr>
                                </tbody>
                            
                            </table>
                            <p>
					       Most local banks offer instant transfers (via FAST), however please be aware that these are not always instant, so we request you not to wait till the last moment to transfer your money. To ensure that money is sighted by us in our bank account well before the cut off, please send your funds as early as possible. 
					        </p>
                           <p>If you wish to transfer money after the validity period has passed (i.e. the transaction has expired), then you will need to initiate a new transaction. Please note that our exchange rates are live and are constantly changing, so the exchange rate on your new transaction may differ from the rate on your old transaction.</p>
				
                        </div>
                    </div>
                  </div>

                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse63">Will I get some sort of proof of the transaction?</a>
                        </h4>
                    </div>
                    <div id="collapse63" class="panel-collapse collapse">
                        <div class="panel-body">
                           <p>Absolutely. You can track the status of your transaction at any time on the Dashboard page. You can also print statements for completed transactions and receipts as PDFs for your own or receiver's reference.</p>
                         
                        </div>
                    </div>
                  </div>

                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse64">I forgot the reference number of my transaction. What do I do? </a>
                        </h4>
                    </div>
                    <div id="collapse64" class="panel-collapse collapse">
                        <div class="panel-body">
                           <p>After initiating the transaction, you will receive an email and SMS notification containing the reference number. Alternatively, you can login to your SingX dashboard and find the reference number under the recent transactions section.</p>
                         
                        </div>
                    </div>
                  </div>

                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse65">Why did my transaction fail? </a>
                        </h4>
                    </div>
                    <div id="collapse65" class="panel-collapse collapse">
                        <div class="panel-body">
                           <p>There are various reasons why a transaction may fail. For example, the receiver's name and account number provided by you may not match, or the receiver's account may be blocked or closed by his or her bank. You can view all your transactions on the Recent transactions page. If a transaction has failed, we will tell you the reason next to it, as soon as we are given the reason from the receiver's bank.</p>
                         
                        </div>
                    </div>
                  </div>

                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse66">My transaction has failed. How do I get my money back? </a>
                        </h4>
                    </div>
                    <div id="collapse66" class="panel-collapse collapse">
                        <div class="panel-body">
                           <p> Not to worry, we will send your money back to the same account from which you sent it to us. Some transaction charges may apply though. You can view all your transactions on the 'Recent transactions' page and the status of your refund will be updated against that transaction.</p>
                         
                        </div>
                    </div>
                  </div>

                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse67">What does 'validity' of a transaction mean?</a>
                        </h4>
                    </div>
                    <div id="collapse67" class="panel-collapse collapse">
                        <div class="panel-body">
                           <p>The exchange rate between currencies is constantly moving, but we allow you to 'lock in' the exchange rate when you create a transaction on our website. The validity of this exchange rate is confirmed to you at the end of the transaction. You need to send the money to our bank account in Hong Kong before the end of this validity period to enjoy the confirmed rate.</p>
                         
                        </div>
                    </div>
                  </div>

                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse68">I have sent money to your account, but status still shows as 'Processing'. What does this mean?</a>
                        </h4>
                    </div>
                    <div id="collapse68" class="panel-collapse collapse">
                        <div class="panel-body">
                           <p>After you have sent money to our account, your transaction status will not change right away. This does not mean that your money hasn't been received. The transaction status will only change after the money is credited into your receiver's account. </p>
                         
                        </div>
                    </div>
                  </div>

                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse69">I raised a transaction on late Friday evening. When will the transaction get completed?</a>
                        </h4>
                    </div>
                    <div id="collapse69" class="panel-collapse collapse">
                        <div class="panel-body">
                           <p>Transactions where money is received in our account after office hours on Friday or on the eve of a public holiday, will get processed on the subsequent working day. Remittances to India will usually be completed within 2 to 5 working hours, after banks open in India on Monday morning. Other corridors will be processed as per the stated processing times.</p>
                         
                        </div>
                    </div>
                  </div>

                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse70">How can I cancel my transaction?</a>
                        </h4>
                    </div>
                    <div id="collapse70" class="panel-collapse collapse">
                        <div class="panel-body">
                           <p>Once a transaction has been created, it cannot be cancelled. If you do not wish to proceed with the transaction, do not transfer the funds to us for processing. However, please note that transactions which have already been processed by SingX cannot be cancelled.</p>
                         
                        </div>
                    </div>
                  </div>


                  <!-- end troubleshoot -->

                  <!-- payment -->
                  <div class="faqHeader">Payment</div>
                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse71">How do I pay by bank transfer?</a>
                        </h4>
                    </div>
                    <div id="collapse71" class="panel-collapse collapse">
                        <div class="panel-body">
                            <p><b>After you create a transaction, we will show you the payment instructions. They will include:</b></p>
                           
                            <ul>
                                <li>A unique transaction reference number</li>
                                <li>The amount you need to send</li>
                                <li>Our bank account details</li>
                            </ul>
                            <p>
                                You can make this transfer online. Simply go to your bank's website, log into your Internet Banking service and make the transfer. It is important that you enter the transaction reference number in the remarks or description field when sending the money through online banking.
                            </p>
                        </div>
                    </div>
                  </div>

                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse72">Can I pay by cheque, cash or card?</a>
                        </h4>
                    </div>
                    <div id="collapse72" class="panel-collapse collapse">
                        <div class="panel-body">
                           <p>Sorry, we do not accept cheque or cash payment. As of now, we have not enabled payment by credit or debit card.</p>
                        </div>
                    </div>
                  </div>

                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse73">What about joint bank accounts? </a>
                        </h4>
                    </div>
                    <div id="collapse73" class="panel-collapse collapse">
                        <div class="panel-body">
                           <p>Yes, you can transfer money from a joint account, if you are the main or second holder on that account.</p>
                         
                        </div>
                    </div>
                  </div>

                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse74">What is the unique transaction number?</a>
                        </h4>
                    </div>
                    <div id="collapse74" class="panel-collapse collapse">
                        <div class="panel-body">
                            <p>After you create a transaction, we will show you the payment instructions. They will include:</p>
                            <ul>
                            <li>A unique transaction reference number</li>
                            <li>The amount you need to send</li>
                            <li>Our bank account details</li>
                            </ul>
                            <p>The unique transaction number is used to uniquely identify your transaction and to track its status.</p>
                            <p>After completing the transaction, you will also receive an email and SMS notification containing the unique transaction reference number.</p>
                           
                        </div>
                    </div>
                  </div>

                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse75">In my bank's screen for making an online payment, there is no place to put in a Transaction Reference Number. What do I do?</a>
                        </h4>
                    </div>
                    <div id="collapse75" class="panel-collapse collapse">
                        <div class="panel-body">
                           <p>If you are unable to provide us the Transaction Reference Number as part of your bank transfer, that's okay. We can still match your payment to your transaction based on your name & account number. However, please ensure that you have cancelled all other valid transactions of the same amount before making the bank transfer to us. If there are multiple transactions of the same amount, SingX reserves the right to fulfil any one of the valid transactions that you have created. Please note that transactions which have already expired or which have been processed by SingX cannot be cancelled.</p>
                        </div>
                    </div>
                  </div>

                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse76">I have created two transactions, but a bank transfer for one of them. How do I let you know which transaction I want to proceed with?</a>
                        </h4>
                    </div>
                    <div id="collapse76" class="panel-collapse collapse">
                        <div class="panel-body">
                            <p>If you want to ensure we fulfil a specific transaction, please cancel all other valid transactions of the same amount before making the bank transfer to us. If there are multiple transactions of the same amount, SingX reserves the right to fulfil any one of the valid transactions that you have created. Please note that transactions which have already expired or which have been processed by SingX cannot be cancelled.</p>
                            
                        </div>
                    </div>
                  </div>
                  <!-- end payment -->
                  <!-- account management -->
                <div class="faqHeader">Account Management</div>
                <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse81">How do I edit profile details?</a>
                        </h4>
                    </div>
                    <div id="collapse81" class="panel-collapse collapse">
                        <div class="panel-body">
                            <P>Please log in and you will see your Dashboard. Click on your name on the top right and select 'Profile' from the drop-down menu. Make the necessary changes to your personal profile details and save the changes.</P>
                        </div>
                    </div>
                </div>

                <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse82">How do I change my password?</a>
                        </h4>
                    </div>
                    <div id="collapse82" class="panel-collapse collapse">
                        <div class="panel-body">
                        <p>Please log in and you will see your Dashboard. Click on your name on the top right and select 'Change Password' from the drop-down menu. Make the necessary changes and save.<br><br>
                            If you forget your username/password or are unable to sign in, click on “Forgot password?” link on the login page. Our password policy is as follows:
                         </p> 
                            <ul>
                                <li>Minimum 8 alphanumeric characters password.</li>
                                <li>At least one letter in uppercase.</li>
                                <li>Must not repeat any letter or number.</li>
                            </ul>	
                        </div>
                    </div>
                </div>

                <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse83">How do I change my email address?</a>
                        </h4>
                    </div>
                    <div id="collapse83" class="panel-collapse collapse">
                        <div class="panel-body">
                        <p> To change your email address, please write to us at<a href="mailto: help.hk@singx.co">help.hk&#64;singx.co</a></p>	
                        </div>
                    </div>
                </div>

                <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse84">How do I change my mobile number?</a>
                        </h4>
                    </div>
                    <div id="collapse84" class="panel-collapse collapse">
                        <div class="panel-body">
                        <p>To change your mobile number, please write to us at <a href="mailto:help.hk@singx.co">help.hk&#64;singx.co</a></p>	
                        </div>
                    </div>
                </div>

                <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse85">How do I add/delete my receiver's bank account?</a>
                        </h4>
                    </div>
                    <div id="collapse85" class="panel-collapse collapse">
                        <div class="panel-body">
                            <b>Add an account</b> <br>
                            <ul>
                            <li>After you log into your account, you will find 'Manage Receivers' link on your dashboard.</li>
                            <li>To add a new receiver: Click on the '+Add' button and enter all the relevant information for the bank account you wish to send money to, and click Save. To confirm the new account, a One-Time Password (OTP) authentication is required. You will receive an OTP on your registered mobile number. Enter the OTP exactly as received and click confirm. Once validated, you will see the confirmation/summary for the bank account you have entered. You can select the receiver's bank from the dropdown list.</li>
                            </ul>
                              <b>Delete an account</b> <br>
                            <ul>
                            <li>To delete an existing receiver bank account: select the respective receiver's bank account and click 'De-activate'. Click 'Confirm' and the selected receiver's bank record will be listed as inactive.</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse86">How do I add/delete my (sender) bank account?</a>
                        </h4>
                    </div>
                    <div id="collapse86" class="panel-collapse collapse">
                        <div class="panel-body">
                            <b>Add an account</b> <br>				
                            <ul>
                            <li>After you log into your account, you will find 'Manage my bank accounts' link on your dashboard. </li>
                            <li>To add new bank details: Click on '+ Add', and enter your new bank details. You can search for your bank by entering the bank name. Click 'Add sender' after all information has been completed. You will now see the new bank details listed on the 'My bank accounts' page.</li>
                            </ul>
                             <b>Delete an account</b> <br>	
                            <ul>
                            <li>We do not allow customers to delete the sender account details due to transaction processing. However, if you wish to delete an account after your transaction has been processed, please write to us at help.hk&#64;singx.co</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse87">What details do I need to add a receiver's account?</a>
                        </h4>
                    </div>
                    <div id="collapse87" class="panel-collapse collapse">
                        <div class="panel-body">	
                            <p>Please ensure you ask the receiver for (i) the receiver's name (ii) receiver's account number and (iii) the receiver's bank name. In addition::</p> 
                                <ul>
                                <li>If you are sending money to India, you will also require the IFSC code and the receiver's address.</li>
                                <li>If you are sending money to Malaysia, you will also require the receiver's nationality, address & contact number, receiver type (whether an individual or business), and if a business then business registration ID.</li>
                                <li>If you are sending money to other corridors, the details may include bank clearing code, branch code, BIC/SWIFT code etc. Simply select which country you want to send to under 'Add Receiver Account' to view the required details.</li>
                                </ul>
                        </div>
                    </div>
                </div>

                <div class="faqHeader">Technical & Browser Queries</div>
                <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse91">What Internet browsers do you support?</a>
                        </h4>
                    </div>
                    <div id="collapse91" class="panel-collapse collapse">
                        <div class="panel-body">
                            <p>Our website is optimised for Safari (version 8 and above) and Google Chrome (Version 43 and above). If you are using our mobile apps (Android or iOS) please ensure that you have updated the app to the latest version that is available.</p>
                        </div>
                    </div>
                </div>

                <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse92">How do I enable cookies?</a>
                        </h4>
                    </div>
                    <div id="collapse92" class="panel-collapse collapse">
                        <div class="panel-body">
                            <b>Google Chrome:</b>
                            <ul>
                            <li>Select 'Settings' from browser menu list.</li>
                            <li>Select 'Show advanced settings...' at the bottom of the page.</li>
                            <li>Under the heading 'Privacy', select 'Content Settings'.</li>
                            <li>Under the heading 'Cookies', select 'Allow local data to be set' and make sure 'Block third-party cookies and site data' is unticked.</li>
                            <li>Click 'Done' in the bottom right-hand corner of the popup window.</li>
                            </ul>
        
                            <b>Safari:</b>
                            <ul>
                            <li>Select 'Safari', next to the Apple logo.</li>
                            <li>Select 'Preferences...', from the drop down menu.</li>
                            <li>Select 'Privacy' in the popup window.</li>
                            <li>In the category 'Cookies and website data', select 'Allow from websites I visit'.</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse93">How do I clear my cache?</a>
                        </h4>
                    </div>
                    <div id="collapse93" class="panel-collapse collapse">
                        <div class="panel-body">
                           <p><b>Google Chrome:</b></p> 
                             <p>Select 'Preference' from browser menu list.</p> 
                            <p>Select 'Show advanced settings...' at bottom of the page.</p>
                            <p>Under the heading 'Privacy', select 'Clear browsing data...'.</p>
                            <p>At the top of the popup window, next to 'Obliterate the following items from:' select your desired duration to clear. (Recommended to be at least 'the last 4 weeks'.)</p>
                            <p>Tick 'Cached images and files'.</p>
                            <p>Click 'Clear browsing data'.</p>
                           
                            <p><b>Safari:</b></p>
                            <p>Select 'Safari', next to the Apple logo.</p>
                            <p>Select 'Preferences...', from drop-down menu.</p>
                            <p>Select the furthest right tab 'Advanced' in popup window.</p>
                            <p>At the bottom of the 'Advanced' window, you should see the option 'Show Develop menu in menu bar'. Tick this.</p>
                            <p>Close popup window.</p>
                            <p>Top of the screen, click on 'Develop' between 'Bookmarks' and 'Window'.</p>
                            <p>In the drop-down menu, click on 'Empty Caches'.</p>
                           
                        </div>
                    </div>
                </div>

                <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse94">How do I take a screenshot?</a>
                        </h4>
                    </div>
                    <div id="collapse94" class="panel-collapse collapse">
                        <div class="panel-body">
                                <p>For Apple MacBook, press command + shift + 3 buttons and screenshot image will be saved on your desktop.</p>
                                <p>For Windows, press Print Screen key and paste to image editor to save the screenshot.</p>
                                <p>For iPhone or iPad, hold down home + lock buttons and screenshot will be saved into camera roll.</p>
                                <p>For Android, please refer to the brand and model manual.</p>
                            
                        </div>
                    </div>
                </div>

                <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse95">Which Internet browser works best for SingX?</a>
                        </h4>
                    </div>
                    <div id="collapse95" class="panel-collapse collapse">
                        <div class="panel-body">
                            <p>Our website is optimised for Safari (version 8 and above) and Google Chrome (Version 43 and above).</p>
                            <p>It is essential to make sure your Internet browser is up-to-date for best user experience and security. Using an outdated browser may pose data security threat.</p>
                           
                        </div>
                    </div>
                </div>
                <div class="faqHeader">Rate Alert</div>
                <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse101">Is my personal data safe?</a>
                        </h4>
                    </div>
                    <div id="collapse101" class="panel-collapse collapse">
                        <div class="panel-body">
                            <p>We take the safety of your personal details very seriously. To facilitate secure data transmission over the Internet, we have all the<span nz-tooltip
                                nzTooltipTitle="System integrity and the confidentiality of your personal and transaction details are our top priority. For data to be transmitted securely over the Internet, we use Secure Socket Layer (SSL), 128-bit encryption within the logged-in site pages. To check if your connection is secure, just look for the https url and the secure padlock symbol at the bottom right of your browser window or in the address bar.All data is held on secure servers hosted by Data Electronics (ISO 9001:2008 and ISO 27001 certified) along with a managed firewall service as well as guaranteed power and connectivity to provide the highest levels of security 24/7." style="color: blue;"> safety precautions</span> in place We have adopted a 
                                <span nz-tooltip
                                nzTooltipTitle="Two-factor authentication improves account security by combining what you know, e.g. 
                                your password, with something that only you possess, such as your mobile phone. When
                                 trying to log in or carry out certain actions, such as transferring money, we will automatically 
                                 send a One-time Password (OTP) to your phone. Enter the OTP into the two-factor authentication form on our site and you can transact with total 
                                 peace of mind after that" style="color: blue;">two-step authentication process</span> 
                                 which ensures complete security and peace of mind. We also ensure that our website keeps your <span nz-tooltip
                                 nzTooltipTitle="Our website uses 256-bit encryption via Secure Socket Layer (SSL) from VeriSign. This means that your connection is secure." style="color: blue;">connection secure</span>  All your account information is stored in a secure facility that is safeguarded by us. </p>
                        </div>
                    </div>
                </div>

                <!-- end global faqs -->
                	<!-- currency alert start here -->
                    <div class="faqHeader">Rate Alert</div>
                    <div class="panel panel-default">
                        <div class="panel-heading">
                            <h4 class="panel-title">
                                <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse111">Do I need to register with SingX to create a rate alert?</a>
                            </h4>
                        </div>
                        <div id="collapse111" class="panel-collapse collapse">
                            <div class="panel-body">
                                <p class=" regular10 color_lightgrey">No, you do not need to register with SingX to subscribe for our rate alerts. However certain features are only available to registered users, hence for full access we recommend that you create an account. Registration is free and easy, click <a href="javascript:void(0)" (click)="redirectToRegistrationPage()">here</a> to sign up now. </p>
                            </div>
                        </div>
                    </div>

                    <div class="panel panel-default">
                        <div class="panel-heading">
                            <h4 class="panel-title">
                                <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse112">Does it cost me anything to setup a rate alert?</a>
                            </h4>
                        </div>
                        <div id="collapse112" class="panel-collapse collapse">
                            <div class="panel-body">
                                <p class=" regular10 color_lightgrey">No, setting up rate alerts with SingX is free of charge for all users. We aim to keep you updated with our live exchange rates so that you can transact at the rates you want!.</p>
                            </div>
                        </div>
                    </div>

                    <div class="panel panel-default">
                        <div class="panel-heading">
                            <h4 class="panel-title">
                                <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse113">What are the different types of rate alert that SingX offers?</a>
                            </h4>
                        </div>
                        <div id="collapse113" class="panel-collapse collapse">
                            <div class="panel-body">
                                <ul>
                                    <li>Rate reaches your desired value: Alert if the rate of the currency pair selected reaches your specified value
                                    </li>
                                    <li>Rate is at its Two-weeks high: Alert if the rate of the currency pair selected is the highest in the past two weeks</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div class="panel panel-default">
                        <div class="panel-heading">
                            <h4 class="panel-title">
                                <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse114">Can I set multiple rate alerts for the same currency pair? (i.e. Three different rate alerts for SGD to INR)</a>
                            </h4>
                        </div>
                        <div id="collapse114" class="panel-collapse collapse">
                            <div class="panel-body">
                                <p>At this time, you can only set one rate alert for each currency pair. However, you can have both types of rate alert set up for the same currency pair. The two types of alert offered on SingX are: a) Rate reaches your desired value b) Rate is at its Two-weeks high. You may edit this rate alert by logging in to your SingX account and selecting Rate Alerts > Manage Alerts.</p>
					
                            </div>
                        </div>
                    </div>

                    <div class="panel panel-default">
                        <div class="panel-heading">
                            <h4 class="panel-title">
                                <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse115">Can I receive the same rate alert via both SMS and Email?</a>
                            </h4>
                        </div>
                        <div id="collapse115" class="panel-collapse collapse">
                            <div class="panel-body">
                                <p>This option is available for all registered users of SingX. If you wish to receive the same type of rate alert via both Email and SMS, then please select “Both” option in the channel of communication.</p>
					
                            </div>
                        </div>
                    </div>

                    <div class="panel panel-default">
                        <div class="panel-heading">
                            <h4 class="panel-title">
                                <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse116">Does the foreign exchange rate involve any markups?</a>
                            </h4>
                        </div>
                        <div id="collapse116" class="panel-collapse collapse">
                            <div class="panel-body">
                                <p>Absolutely not. SingX provides 100% transparency with no hidden fees or foreign exchange markups. The rate alert that you receive is for the live, mid-market exchange rate.</p>
					
                            </div>
                        </div>
                    </div>

                    <div class="panel panel-default">
                        <div class="panel-heading">
                            <h4 class="panel-title">
                                <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse117">Will you hold the foreign exchange rate that I receive via the rate alert email/SMS notification for me to transact at?</a>
                            </h4>
                        </div>
                        <div id="collapse117" class="panel-collapse collapse">
                            <div class="panel-body">
                               
					      <p>Unfortunately, no. SingX provides live foreign exchange rates that are always fluctuating. Hence, we are unable to hold a specific rate indicated in the rate alert for customers. If you would like to enjoy the FX rate indicated in the rate alert, please log on to the SingX portal and book a transaction as soon as possible. After this, you will need to transfer the funds to SingX as indicated on the transaction page.</p>
					
                            </div>
                        </div>
                    </div>

                    <div class="panel panel-default">
                        <div class="panel-heading">
                            <h4 class="panel-title">
                                <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse118">How many times will I receive alerts if the foreign exchange rate exceeds the limit that I set? (i.e. I set up an alert if 1 SGD crosses 46 INR)</a>
                            </h4>
                        </div>
                        <div id="collapse118" class="panel-collapse collapse">
                            <div class="panel-body">
                                <p>We will send you rate alerts five times if the rate crosses your set limit. For example, if you set a rate alert of 1 HKD to go above 200 INR, the rate alert notification will be sent 5 times (1 per day) when the rate goes above 200. After receiving the alert 5 times, you will then receive an email notification to set a new rate alert if you wish to continue receiving the alerts.</p>
					
                            </div>
                        </div>
                    </div>

                    <div class="panel panel-default">
                        <div class="panel-heading">
                            <h4 class="panel-title">
                                <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse119">How does a two-week high alert work?</a>
                            </h4>
                        </div>
                        <div id="collapse119" class="panel-collapse collapse">
                            <div class="panel-body">
                                <p>If the rate for your currency pair is the highest in the past two weeks, you will receive a rate alert. For example, if you set a two-week high rate alert for HKD to USD, you will receive an alert if this condition is met. The two-week high rate alerts will be sent 5 times, after which you will receive an email notification to set a new rate alert if you wish to continue receiving the alerts.</p>
					
                            </div>
                        </div>
                    </div>

                    <div class="panel panel-default">
                        <div class="panel-heading">
                            <h4 class="panel-title">
                                <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse1110">How can I edit my existing alerts?</a>
                            </h4>
                        </div>
                        <div id="collapse1110" class="panel-collapse collapse">
                            <div class="panel-body">
                                <ul>
                                    <li>
                                        If you are a registered user with SingX: log in to your account, click on your profile, select Rate Alerts ,Manage Alerts. You can edit your existing alert by clicking on the edit icon shown at the end.
                                    </li>
                                      <li>If you are not a registered user with SingX, you are unable to edit your alert. However, you can delete the alert by using the unsubscribe link in the rate alert email and then create a new one.</li>
                                      </ul>	
                            </div>
                        </div>
                    </div>

                    <div class="panel panel-default">
                        <div class="panel-heading">
                            <h4 class="panel-title">
                                <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse1111">How many times will I receive rate alerts in one day?</a>
                            </h4>
                        </div>
                        <div id="collapse1111" class="panel-collapse collapse">
                            <div class="panel-body">
                                <p>You will receive one rate alert every 24 hours.</p>
					
                            </div>
                        </div>
                    </div>

                    <div class="panel panel-default">
                        <div class="panel-heading">
                            <h4 class="panel-title">
                                <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse1112">How do I unsubscribe from the rate alerts?</a>
                            </h4>
                        </div>
                        <div id="collapse1112" class="panel-collapse collapse">
                            <div class="panel-body">
                            
                                    <ul>
                                      <li>If you are a registered user with SingX: log in to your account, click on your profile, select Rate Alerts -> Manage Alerts and simply delete the alerts you would like to unsubscribe from</li>
                                      <li>If you are not a registered user with SingX, simply click on the unsubscribe link in the SingX rate alert emails you have reeived.</li>
                                      </ul>
                            </div>
                        </div>
                    </div>

                    <div class="panel panel-default">
                        <div class="panel-heading">
                            <h4 class="panel-title">
                                <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse1113">Can I share the rate alert with my friends?</a>
                            </h4>
                        </div>
                        <div id="collapse1113" class="panel-collapse collapse">
                            <div class="panel-body">
                            
                                <p>Absolutely! Feel free to share this rate with your friends on social media or via email to help them enjoy unbeatable exchange rates with SingX.</p>
					
					
                            </div>
                        </div>
                    </div>

                    <div class="panel panel-default">
                        <div class="panel-heading">
                            <h4 class="panel-title">
                                <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse1114">Who can I contact if I still have questions?</a>
                            </h4>
                        </div>
                        <div id="collapse1114" class="panel-collapse collapse">
                            <div class="panel-body">
                                <p>Feel free to contact our helpful customer service team at help.hk&#64;singx.co so they can guide you through the process of setting up rate alerts on our website.</p>
					
					
                            </div>
                        </div>
                    </div>

                    <!-- currency alert end here -->

                </div>
            </div>
            <!--end container -->
        </div>
        <!--end services-wrapper -->
    </section>
    <!-- End FAQs for Hk -->

      <!-- FAQs For AU -->
      <section *ngIf="country == 'au'">
        <!--begin services-wrapper -->
        <div class="services-wrapper">
            <!--begin container -->
            <div class="container">
                <br />
                <br />
                <br />
            
            
                <br />
            
                <div class="panel-group FAQ" id="accordion"> 
                <div>
                    <h1 style="font-size: 34px; color: #FF6600; font-weight: 500;">Frequently Asked Questions (FAQs)</h1>
                 </div>
                    <div class="faqHeader">General</div>
                    <div class="panel panel-default">
                        <div class="panel-heading">
                            <h4 class="panel-title">
                                <a class="accordion-toggle" data-toggle="collapse" data-parent="#accordion" href="#collapseOne">1. Am I eligible to sign up?</a>
                            </h4>
                        </div>
                        <div id="collapseOne" class="panel-collapse collapse in">
                            <div class="panel-body">
                                <p> If you are a resident of Australia, you can sign up with us. It's simple and free, so <a href="javascript:void(0)" (click)="redirectToRegistrationPage()" style="cursor:pointer; color: blue;">start now.</a></p>
                                
                            </div>
                        </div>
                    </div>
                    <div class="panel panel-default">
                        <div class="panel-heading">
                            <h4 class="panel-title">
                                <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapseTen">2. Which countries can I transfer money to?</a>
                            </h4>
                        </div>
                        <div id="collapseTen" class="panel-collapse collapse">
                            <div class="panel-body">
                                <p> You can send money to more than 30 countries. Please<a routerLink="/country-details" style="cursor:pointer; color: blue;"> click here </a> to view details.</p>
                               
                            </div>
                        </div>
                    </div>
                    <div class="panel panel-default">
                        <div class="panel-heading">
                            <h4 class="panel-title">
                                <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapseEleven">3. How much does it cost?</a>
                            </h4>
                        </div>
                        <div id="collapseEleven" class="panel-collapse collapse">
                            <div class="panel-body">
                                <p>
                                    In a majority of cases, especially for stable and frequently traded currencies, the transaction fee is up to 0.5% of the mid-market rate and a reflection of your total fee. 
                                    In the case of less frequently traded currencies or ones that are likely to be volatile, SingX may charge a fx mark up (a difference between the foreign exchange charged and the prevailing inter-bank rate) and/or a flat fee and 3rd party fees,
                                    should the beneficiary's bank at destination apply this, in addition to the transaction fee.
                                </p>
                                <p>Check out the <a href="/" style="cursor:pointer; color: blue;"> Fair Exchange Calculator </a>  to find out the exact fee we charge and how much you save by transacting through us.</p>
                                 <p>Our charges are fully transparent so that there are no surprises. Unlike banks or other money transfer operators, there are no hidden charges, no cable fees, no bank commissions, and no hefty foreign exchange mark-ups.</p>
                            </div>
                        </div>
                    </div>

                    <div class="panel panel-default">
                        <div class="panel-heading">
                            <h4 class="panel-title">
                                <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapsetwelve">4. How long does it take?</a>
                            </h4>
                        </div>
                        <div id="collapsetwelve" class="panel-collapse collapse">
                            <div class="panel-body">
                                <p>
                                    After we have received your money, it will typically take us 1-2 working days to credit your nominated receiver's bank account in most cases. This depends on the speed of Internet Banking transfers in the receiver's country . For more details on processing times, please <a routerLink="/country-details" style="color: blue;"> click here</a>.
                                </p>
                                
                            </div>
                        </div>
                    </div>

                    <div class="panel panel-default">
                        <div class="panel-heading">
                            <h4 class="panel-title">
                                <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapsethirteen">5. Is my money safe?</a>
                            </h4>
                        </div>
                        <div id="collapsethirteen" class="panel-collapse collapse">
                            <div class="panel-body">
                                <p> The safety of your money is as important to us, as it is to you. Your money is safe with us for 4 reasons:</p>
                                <ol>
                                    <li><p><b>Your funds are kept in a segregated client account.</b><br>As a regulated payment services provider, we must hold all money transferred by our clients in segregated bank accounts. These accounts are separate from our own bank accounts. So, your money is never mixed with ours, and we cannot use your money to settle any of our own obligations.</p></li>
                                    <li><p><b>We have a credible and trustworthy team.</b><br>
                                        The Shareholders and Directors of SingX are professionals who have worked with reputed multinational banks throughout their careers. They operate with the highest levels of integrity. Click <a routerLink="/team" style="color: blue;">here</a>  to read about the profiles of our key management.</p></li>
                                    <li>
                                        <p><b>We work with Licensed Remittance Operators (LROs) in each country.</b><br>
						
                                            These LROs are licensed to do remittance transactions by the Central Bank in their respective countries. Click <a routerLink="/licenses">here</a>
                                            for more details on the licensed entities we deal with.
                                    </li>
                                    <li>
                                        <p><b>We implement a host of security measures, just like the banks.</b><br>
                                            We take the safety of your personal details very seriously. To facilitate secure data transmission over the Internet, 
                                            we have all the secure precautions in place. We have adopted a two-step authentication process which ensures complete security and peace of mind. We also ensure that our website keeps your connection secure. 
                                            All your account information is stored in a secure facility that is safeguarded by us. </p>
                        
                                </ol>
                            </div>
                        </div>
                    </div>
                    
                    <div class="panel panel-default">
                        <div class="panel-heading">
                            <h4 class="panel-title">
                                <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapsefourteen">6. How do I sign up?</a>
                            </h4>
                        </div>
                        <div id="collapsefourteen" class="panel-collapse collapse">
                            <div class="panel-body">
                                <ol class=" color_lightgrey paddingbullet" style="list-style-type: none;" >
										
                                    <p>Step 1: <a href="javascript:void(0)" (click)="redirectToRegistrationPage()">Click here</a> to get started.</p>
                                    <p>Step 2: Complete your registration online.<br> 
                                        SingX is governed by the same regulations as your bank. For personal accounts, please <a href="javascript:void(0)" (click)="redirectToRegistrationPage()">click here</a>
                                        to sign up online. Once you have provided all the required information your account will be activated instantly.</p>
                                     <p>For businesses, please <a href="http://business.singx.co/"> click here</a> to sign up online. Once we have received your application, we'll need approximately 1 working day to activate your account.</p>   
                                </ol>
                            </div>
                        </div>
                    </div>
            
                    <div class="panel panel-default">
                        <div class="panel-heading">
                            <h4 class="panel-title">
                                <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapsefifteen">7. How do I make a transaction?</a>
                            </h4>
                        </div>
                        <div id="collapsefifteen" class="panel-collapse collapse">
                            <div class="panel-body">
                                <p>Before you start a transaction, make sure that you have completed the <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapsefourteen">sign up process</a> and received an email from us confirming that your account is ready.</p>
                                <ol class=" color_lightgrey paddingbullet" >
                                        <ul class="regular10 color_lightgrey paddingbullet">
                                            <p>1) Use our <a href="/" style="color: blue;"> Fair Exchange Calculator</a>  to check the savings you can enjoy. <br>
                                                Choose the currencies you wish to transfer from and to, as well as the amount you wish to send.</p>
                                              
                                            <p>
                                              2) With a few simple clicks, confirm the transaction and then transfer the money. Follow these simple steps to confirm your transaction:
                                            </p>
                                        </ul>
                                    <ul class="regular10 color_lightgrey paddingbullet">
                                        <li><p>Log into your registered account.</p></li>
                                        <li><p>Click 'Start Your Transfer' to confirm that you want to transfer money.</p></li>
                                        <li><p>Confirm the amount and currency.</p></li>
                                        <li><p>Enter the receiver's details or select from your favourites.</p></li>
                                        <li><p>Next, simply transfer the amount you are sending plus the SingX fee from your local bank account to our local bank account in Australia using either Internet Banking or Poli or other options as mentioned on our website
                                        </p></li>
                                    </ul>
                                    <ul class="regular10 color_lightgrey paddingbullet">
                                        <li><p>3)Sit back, relax and we'll take care of the rest.</p></li>
                                        <li><p>Say goodbye to hidden charges, cable fees, bank commissions and hefty foreign exchange mark-ups. We convert your money and deposit it in your receiver's bank account. You will be notified via email and SMS upon successful transfer.</p></li>
                                        
                                    </ul>

                                    </ol>
                            </div>
                        </div>
                    </div>

                    <div class="panel panel-default">
                        <div class="panel-heading">
                            <h4 class="panel-title">
                                <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapsesixteen">8. How much can I send?</a>
                            </h4>
                        </div>
                        <div id="collapsesixteen" class="panel-collapse collapse">
                            <div class="panel-body">
                                <p>Please <a href="/country-details" style="color: blue;">click here</a> to view details.</p>
                            </div>
                        </div>
                    </div>

                    <div class="panel panel-default">
                        <div class="panel-heading">
                            <h4 class="panel-title">
                                <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapseseventeen">9. How can I contact SingX?</a>
                            </h4>
                        </div>
                        <div id="collapseseventeen" class="panel-collapse collapse">
                            <div class="panel-body">
                                <p>Should you require assistance of any kind, you can email our Customer Care at <a href="mailto:help.au@singx.co" >help.au&#64;singx.co</a> You can contact our customer service agents via our 'Live Chat' between 12 am to 9 pm (Monday to Friday), or leave an offline message via the chat outside these operating hours.</p>
                            </div>
                        </div>
                    </div>

                    <div class="faqHeader">Basic Information</div>
                    <div class="panel panel-default">
                        <div class="panel-heading">
                            <h4 class="panel-title">
                                <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapseTwo">Why should I use SingX?</a>
                            </h4>
                        </div>
                        <div id="collapseTwo" class="panel-collapse collapse">
                            <div class="panel-body">
                                <p>Here are 3 compelling reasons why you should use SingX for cross-border money transfers and international payments:</p>
                                <ol class=" color_lightgrey paddingbullet"  >
                                                                
                                <li><p><b>Enjoy great savings</b><br>You save up to 8% of the transaction amount every time you transfer money through us. Banks and other operators will usually charge you a hefty mark-up on the foreign exchange rate and have layers of hidden fees like cable charges and commission. SingX only charges a single small transparent fee.</p></li>
                                <li><p><b>Enjoy speedy transfers</b><br>After we have received your money, it will typically take us between 1 and 2 working days to credit your nominated receiver's bank account, depending on the speed of Internet Banking transfers in the receiver's country. For more details on processing times, please <a routerLink="/country-details" style="color: blue;">click here</a>.  
                                </li>
                                <li><p><b>Enjoy the online convenience </b><br>Say goodbye to filling in complicated wire transfer forms, signing and delivering original documents to your bank branch only to learn that you have filled the form incorrectly. With us, it's way simpler. Your information is stored with us. You simply confirm that you are happy with the exchange rate and then transfer money to us online.</p></li>
                                                                    
                                </ol>
                            </div>
                        </div>
                    </div>
                    <div class="panel panel-default">
                        <div class="panel-heading">
                            <h4 class="panel-title">
                                <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapseThree">Which countries can I transfer money from?</a>
                            </h4>
                        </div>
                        <div id="collapseThree" class="panel-collapse collapse">
                            <div class="panel-body">
                                <p>You can transfer money from Australia, Singapore and Hong Kong.</p>
                            </div>
                        </div>
                    </div>
            
                    <div class="faqHeader">Signing Up</div>
                    <div class="panel panel-default">
                        <div class="panel-heading">
                            <h4 class="panel-title">
                                <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapseFour">What is the registration process?</a>
                            </h4>
                        </div>
                        <div id="collapseFour" class="panel-collapse collapse">
                            <div class="panel-body">
                                <ol class=" color_lightgrey paddingbullet" style="list-style-type: none;" >
										
                                    <li><p><b>Step 1: Click here to get started.</b><br>
                                    </p></li>
                                    <li><p><b>Step 2: Complete your registration online.</b><br>SingX is governed by the same regulations as your bank. For personal accounts, please click here to sign up online. Once you have provided all the required information your account will be activated instantly.</p></li><br>
                                 
                                    <li>For businesses, please <a href="https://business.singx.co/" style="color: blue;">click here</a> to sign up online. Once we have received your application, we'll need approximately 1 working day to activate your account.
                                    
                                </ol>
                            </div>
                        </div>
                    </div>
                    <div class="panel panel-default">
                        <div class="panel-heading">
                            <h4 class="panel-title">
                                <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapseSeven">What documents are required? </a>
                            </h4>
                        </div>
                        <div id="collapseSeven" class="panel-collapse collapse">
                            <div class="panel-body">
                                <p>For personal accounts, we do not require any documents. You just need to provide details of any two of the following identification documents:</p>
                                  <p>1) Driver's License. <br>
                                     2) Medicare Card. <br>
                                     3) Passport.                                
                                    </p>
                            </div>
                        </div>
                    </div>

                    <div class="panel panel-default">
                        <div class="panel-heading">
                            <h4 class="panel-title">
                                <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapseeight">Does it cost anything to register with SingX?</a>
                            </h4>
                        </div>
                        <div id="collapseeight" class="panel-collapse collapse">
                            <div class="panel-body">
                                <p>Signing up with us is absolutely free!</p>
                            </div>
                        </div>
                    </div>

                 

                  <!-- remittance -->
                  <div class="faqHeader">Rates, Charges & Savings</div>
                  <div class="panel panel-default">
                      <div class="panel-heading">
                          <h4 class="panel-title">
                              <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse41">What are the real savings?</a>
                          </h4>
                      </div>
                      <div id="collapse41" class="panel-collapse collapse">
                          <div class="panel-body">
                            <p>You will save a lot of money. How much you save will vary, depending on the amount you transfer and the currencies involved. To calculate the savings on a transaction you may be considering, check out our <a routerLink="/" style="cursor:pointer;">Fair Exchange Calculator</a>. 
                            </p>
                            <p>We constantly compare our fee to that of banks, remittance agents, card companies and others. These operators usually charge you a hefty mark-up on the foreign exchange rate and have layers of hidden fees like cable fees and commissions.</p>
                            <p>We save you money by using the mid-market rate. This is the wholesale rate at which the big banks transact with each other. While other retail players apply a 'mark-up' on this rate, we offer the wholesale mid-market rate. We charge a small transparent fee which is shown to you upfront.</p>
                            <p>Still not sure? Feel free to compare our rates with those offered by other providers.</p>
                          </div>
                      </div>
                  </div>
                  <div class="panel panel-default">
                      <div class="panel-heading">
                          <h4 class="panel-title">
                              <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse42">Will I be charged any fees/charges other than what I see in the Fair Exchange Calculator?</a>
                          </h4>
                      </div>
                      <div id="collapse42" class="panel-collapse collapse">
                          <div class="panel-body">
                              <p>Absolutely not. Our changes are fully transparent so there are no surprises. Unlike banks or other money transfer operators, there are no hidden charges, no cable fees, no bank commissions and no hefty foreign exchange markups.</p>
                              <p>Check out the <a href="/" style="cursor: pointer; color: blue;">Fair Exchange Calculator</a> to find out the exact fee we charge and how much you save by transacting through us.</p>
                          
                          </div>
                      </div>
                  </div>

                  <div class="panel panel-default">
                      <div class="panel-heading">
                          <h4 class="panel-title">
                              <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse43">How do your charges compare with the banks? </a>
                          </h4>
                      </div>
                      <div id="collapse43" class="panel-collapse collapse">
                          <div class="panel-body">
                              <p>A bank levies a number of charges including foreign exchange mark-ups, cable charges, commission and receiving bank charges.</p>
                              <p>Besides, if you are converting from one Asian currency to another Asian currency, the bank will first convert the Asian currency to US Dollar and levy a foreign exchange mark-up. They will then convert the US Dollar into the other Asian currency you wish to convert to and levy a second foreign exchange mark-up.</p>
                              <p>So if you're comparing our transparent rate with that offered by your bank, make sure you add all these hidden charges.</p>
                             <p>To quantify your savings potential, please refer to our <a routerLink="/" style="cursor:pointer;">Fair Exchange Calculator</a>.
                            </p>
                          </div>
                      </div>
                  </div>

                  
                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse44">How does your rate compare with Western Union or other money transfer operators?</a>
                        </h4>
                    </div>
                    <div id="collapse44" class="panel-collapse collapse">
                        <div class="panel-body">
                           <p>Western Union and other money transfer operators levy a fixed fee and a foreign exchange mark-up. A World Bank study shows that the average transaction fee charged by money transfer operators is upto 8% of the transaction amount.</p>
                        </div>
                    </div>
                  </div>


                  <!-- end remittance -->

                  <!-- create transfer request -->
                  <div class="faqHeader">Create A Transfer Request</div>
                  <div class="panel panel-default">
                      <div class="panel-heading">
                          <h4 class="panel-title">
                              <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse51">How do I pay for the transfer?</a>
                          </h4>
                      </div>
                      <div id="collapse51" class="panel-collapse collapse">
                          <div class="panel-body">
                            <p>Simply go to your bank's website, log into your Internet Banking service and make the transfer to our Australia bank account. It is important that you enter the transaction reference number in the remarks or description field when sending the money through online banking.
                            </p>
                          </div>
                      </div>
                  </div>
                  <div class="panel panel-default">
                      <div class="panel-heading">
                          <h4 class="panel-title">
                              <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse52">How can I schedule money transfers on a monthly or periodic basis? </a>
                          </h4>
                      </div>
                      <div id="collapse52" class="panel-collapse collapse">
                          <div class="panel-body">
                            <p>All the details of the receiver's bank account are stored (view under 'Manage my receivers'). So, if you wish to make repeat transfers to the same receiver, all you need to do is Re-book. It's that simple.</p>
                            <p>We cannot take standing instructions for recurring transfers though. You will have to create a new transaction each time. Simply click on Re-book button next to an old transaction, check the exchange rate, confirm the transaction, and you are on your way. Once we receive your money, we will execute your repeat payment.</p>
                          </div>
                      </div>
                  </div>

                  <div class="panel panel-default">
                      <div class="panel-heading">
                          <h4 class="panel-title">
                              <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse53">Can I add more than one of my bank accounts to my SingX account?</a>
                          </h4>
                      </div>
                      <div id="collapse53" class="panel-collapse collapse">
                          <div class="panel-body">
                             <p>Yes, you can add any number of your bank accounts to your SingX account. Remember that you can transfer money from a bank account only if you are the main or joint holder on that account.
                            </p>
                          </div>
                      </div>
                  </div>

                  
                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse54">Can I send money from my spouse's or family member's bank account to a receiver's account? </a>
                        </h4>
                    </div>
                    <div id="collapse54" class="panel-collapse collapse">
                        <div class="panel-body">
                           <p>You can only send money from an account where your name is on the bank account. So if you have a joint account with your spouse or a family member, then you may send money from that joint account. If, however, your name is not on the account, then you cannot send money from that bank account. Instead, please invite them to sign up with us.</p>
                        </div>
                    </div>
                  </div>

                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse55">Can I transfer money from a joint bank account? </a>
                        </h4>
                    </div>
                    <div id="collapse55" class="panel-collapse collapse">
                        <div class="panel-body">
                           <p>Yes, you can transfer money from a joint account, if you are the main or second holder on that account.</p>
                        </div>
                    </div>
                  </div>

                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse55c">Can my receiver receive money in cash?</a>
                        </h4>
                    </div>
                    <div id="collapse55c" class="panel-collapse collapse">
                        <div class="panel-body">
                           <p>SingX offers cash pay-outs only in Philippines.</p>
                        </div>
                    </div>
                  </div>

                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse56c">Where can my recipient collect the funds in the Philippines?</a>
                        </h4>
                    </div>
                    <div id="collapse56c" class="panel-collapse collapse">
                        <div class="panel-body">
                           <p>You can choose any one of the following pay-out partners' locations in Philippines:</p>
                           <table id="customers">
                            <tbody><tr>
                              <th>No</th>
                              <th>Name</th>
                              <th>Website</th>
                            </tr>
                            <tr>
                            <td>1</td>
                            <td>BDO Cash Pickup</td>
                            <td><a href="https://www.bdo.com.ph/branches-atms-locator">https://www.bdo.com.ph/branches-atms-locator</a></td>
                            </tr>
                            <tr>
                            <td>2</td>
                            <td>M Lhuillier</td>
                            <td><a href="http://www.mlhuillier.com/branches/">http://www.mlhuillier.com/branches/</a></td>
                            </tr>
                            <tr>
                            <td>3</td>
                            <td>Cebuana Lhuillier</td>
                            <td><a href="https://www.cebuanalhuillier.com/">https://www.cebuanalhuillier.com/</a></td>
                            </tr>
                            <tr>
                            <td>4</td>
                            <td>Palawan Pawnshop</td>
                            <td><a href="http://www.palawanpawnshop.com/pera-padala">http://www.palawanpawnshop.com/pera-padala</a></td>
                            </tr>
                            <tr>
                            <td>5</td>
                            <td>LBC Express</td>
                            <td><a href="https://lbcexpress.com/">https://lbcexpress.com/</a></td>
                            </tr>
                            <tr>
                            <td>6</td>
                            <td>BPI</td>
                            <td><a href="https://secure1.bpiexpressonline.com/locator/search.aspx?loc=BRANCH">https://secure1.bpiexpressonline.com/locator/search.aspx?loc=BRANCH</a></td>
                            </tr>
                            <tr>
                            <td>7</td>
                            <td>Metrobank</td>
                            <td><a href="https://www.metrobank.com.ph/locate_branch.asp">https://www.metrobank.com.ph/locate_branch.asp</a></td>
                            </tr>
                            <tr style="display: none;">
                            <td>8</td>
                            <td>SM Counters</td>
                            <td><a href="https://www.bdo.com.ph/branches-atms-locator">https://www.bdo.com.ph/branches-atms-locator</a></td>
                            </tr>
                        </tbody>
                    </table>
                        </div>
                    </div>
                  </div>

                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse57c">When will funds be available for collection in the Philippines?</a>
                        </h4>
                    </div>
                    <div id="collapse57c" class="panel-collapse collapse">
                        <div class="panel-body">
                           <p>If you send money to us on a business day during business hours, the money will be available for pick-up in Philippines usually within 1-2 hours. If you have sent money to us after 4pm SGT, then its best that you ask the beneficiary to go to the pick-up location on the next business day. Sometimes we may require further information from you before we can process the transfer in order to comply with our regulatory requirements. We will email you if this is the case.</p>
                        </div>
                    </div>
                  </div>

                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse58c">How long does the receiver have to pick up the cash?</a>
                        </h4>
                    </div>
                    <div id="collapse58c" class="panel-collapse collapse">
                        <div class="panel-body">
                           <p>Your receiver needs to pick up the cash within 28 working days.</p>
                        </div>
                    </div>
                  </div>

                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse59c">What information do I need from my recipient to pick up cash in the Philippines?</a>
                        </h4>
                    </div>
                    <div id="collapse59c" class="panel-collapse collapse">
                        <div class="panel-body">
                           <p>Your receiver needs to go in person to the pay-out partner's location. The receiver must carry a valid photo ID (Driver’s license, passport, or any local government-issued photo ID, or a student ID). The receiver will also need to mention your (the sender’s name), our service operators name (Tranglo), the transfer amount and a unique PIN that is sent to him via SMS. In the interest of safety, sometimes our pay-out partners may ask additional questions to establish the receiver's identity.</p>
                        </div>
                    </div>
                  </div>

                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse192">Will I get a FIRC for the money I transfer to India?</a>
                        </h4>
                    </div>
                    <div id="collapse192" class="panel-collapse collapse">
                        <div class="panel-body">
                            <p>Your receiver needs to go in person to the pay-out partner's location. The receiver must carry a valid photo ID (Driver's license, passport, or any local government-issued photo ID, or a student ID). The receiver will also need to mention your (the sender's name), our service operators name (Tranglo), the transfer amount and a unique PIN that is sent to him via SMS. In the interest of safety, sometimes our pay-out partners may ask additional questions to establish the receiver’s identity.Yes, your receiver can apply for a Foreign Inward Remittance Certificate (certificate of inward remittance) from his or her bank. Your beneficiary bank will contact our bank in India to confirm that the origin of the funds was indeed from outside of India.</p>
                            <p>Note that payments for the following purposes are only allowed through banking channels as per RBI guidelines:</p>
                            <ol class="color_lightgrey paddingbullet">
                                <li><p>Foreign Direct Investment (FDI)</p></li>
                                <li><p>Foreign Institutional Investment (FII)</p></li>
                            </ol>
                            <p>This means we can't complete transfers for FDI/FII on your behalf, so a FIRC can't be issued.</p>
                        </div>
                    </div>
                  </div>
                  <!-- end create transfer request -->
                  <!-- trubleshoot -->
                  <div class="faqHeader">Troubleshoot Active Transactions</div>
                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse61">My receiver has not received the money. What do I do?</a>
                        </h4>
                    </div>
                    <div id="collapse61" class="panel-collapse collapse">
                        <div class="panel-body">
                           <p>Once we have received your funds in our client account, the remittances are typically completed in 1-2 days. Remittances to some corridors may take longer.</p>
                           <p>In some cases, it may take 1 to 5 working days depending on the efficiency of internet banking at your receiver's bank. Please check the status of your transaction on the Dashboard. If for any reason, we were unable to credit the receiver's account, you can track your refund there too. For further help, please email us at <a href="mailto:help.au@singx.co" style="color: blue; cursor: pointer;">help.au&#64;singx.co</a></p>
                        </div>
                    </div>
                  </div>

                  
                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse62">Will my transaction expire?</a>
                        </h4>
                    </div>
                    <div id="collapse62" class="panel-collapse collapse">
                        <div class="panel-body">
                            <p>
                                Once you have confirmed a transaction, it is valid at that exchange rate for a fixed period. We must sight your funds in our bank account before the transaction expires. If we receive your money in our bank account after the transaction has expired, we will not be able to proceed with it.
                            </p>
                            <p>To ensure that money is sighted by us in our bank account well before the cut off, please send your funds as soon as you book a transaction.</p>
                            <p>If you wish to transfer money after the validity period has passed (i.e. the transaction has expired), then you will need to initiate a new transaction. Please note that our exchange rates are live and are constantly changing, so the exchange rate on your new transaction may differ from the rate on your old transaction</p>
					<style>
                        table#customers {
                            font-size:15px;
                            border-collapse: collapse;
                            border-spacing: 0;
                            width: 70%;
                            border: 1px solid #f60;
                        }
                        
                        #customers td, #customers th {
                            border-bottom: 1px solid #f60;
                            padding: 8px;
                        }
                        
                        #customers tr:nth-child(even){background-color: #FFEAE7}
                        
                        #customers th {
                            padding-top: 11px;
                            padding-bottom: 11px;
                            background-color: #f60;
                            color: white;
                        }
                        
                        
                        </style>
                        	<table id="customers">
                                <tbody><tr>
                                  <th>Transaction Created On</th>
                                  <th>Transaction Valid Until</th>
                                  <th>Transaction Processed On**</th>
                                </tr>
                                <tr>
                                <td>Tuesday, 10am</td>
                                <td>Tuesday, 5pm</td>
                                <td>Tuesday</td>
                                </tr>
                                <tr class="alt">
                                <td>Tuesday, 6pm   </td>
                                <td>Wednesday, 5pm</td>
                                <td>Wednesday</td>
                                </tr>
                                <tr>
                                <td>Friday, 7pm* </td>
                                <td>Saturday, 5pm</td>
                                <td>Monday</td>
                                </tr>
                                <tr class="alt">
                                <td>Saturday, 10am* </td>
                                <td>Saturday, 5pm</td>
                                <td>Monday</td>
                                </tr>
                                
                                <tr>
                                  <td colspan="3" style="text-align:left;font-size:13px;">
                                   <b> <i>* The Status on your dashboard will remain unchanged till Monday.</i></b><br>
                                    <b><i>** The transaction will be processed subject to funds being received within transaction validity period.</i></b>
                                  </td>
                                </tr>
                                </tbody>
                            
                            </table>
                            <p>
					       Most local banks offer instant transfers (via FAST), however please be aware that these are not always instant, so we request you not to wait till the last moment to transfer your money. To ensure that money is sighted by us in our bank account well before the cut off, please send your funds as early as possible. 
					        </p>
                           <p>If you wish to transfer money after the validity period has passed (i.e. the transaction has expired), then you will need to initiate a new transaction. Please note that our exchange rates are live and are constantly changing, so the exchange rate on your new transaction may differ from the rate on your old transaction.</p>
				
                        </div>
                    </div>
                  </div>

                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse63">Will I get some sort of proof of the transaction?</a>
                        </h4>
                    </div>
                    <div id="collapse63" class="panel-collapse collapse">
                        <div class="panel-body">
                           <p>Absolutely. You can track the status of your transaction at any time on the Dashboard page. You can also print statements for completed transactions and receipts as PDFs for your own or receiver's reference.</p>
                         
                        </div>
                    </div>
                  </div>

                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse64">I forgot the reference number of my transaction. What do I do? </a>
                        </h4>
                    </div>
                    <div id="collapse64" class="panel-collapse collapse">
                        <div class="panel-body">
                           <p>After initiating the transaction, you will also receive an email and SMS notification containing the reference number. If you are still not sure, please feel free to email us at <a href="mailto:help.au@singx.co." style="cursor: pointer; color: blue;"> help.au&#64;singx.co.</a></p>
                         
                        </div>
                    </div>
                  </div>

                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse65">Why did my transaction fail? </a>
                        </h4>
                    </div>
                    <div id="collapse65" class="panel-collapse collapse">
                        <div class="panel-body">
                            <p>There are various reasons why a transaction may fail. For example, the receiver's name and account number provided by you may not match, or the receiver's account may be blocked or closed by his or her bank. You can view all your transactions on the 'Recent transactions' page.</p>
                            <p>For further enquiries, please email us at <a href="mailto: help.au@singx.co"> help.au&#64;singx.co.</a></p>
                         
                        </div>
                    </div>
                  </div>

                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse66">My transaction has failed. How do I get my money back? </a>
                        </h4>
                    </div>
                    <div id="collapse66" class="panel-collapse collapse">
                        <div class="panel-body">
                           <p>Not to worry, we will send your money back to the same account from which you sent it to us. Some transaction charges may apply though. You can view all your transactions on the 'Recent transactions' page and the status of your refund will be updated against that transaction.</p>
                         
                        </div>
                    </div>
                  </div>

                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse67">What does 'validity' of a transaction mean?</a>
                        </h4>
                    </div>
                    <div id="collapse67" class="panel-collapse collapse">
                        <div class="panel-body">
                           <p>The exchange rate between currencies is constantly moving, but we allow you to 'lock in' the exchange rate when you create a transaction on our website. The validity of this exchange rate is confirmed to you at the end of the transaction. You need to send the money to our bank account in Australia before the end of this validity period to enjoy the confirmed rate.</p>
                         
                        </div>
                    </div>
                  </div>

                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse68">I have sent money to your account, but status still shows as 'Processing'. What does this mean?</a>
                        </h4>
                    </div>
                    <div id="collapse68" class="panel-collapse collapse">
                        <div class="panel-body">
                           <p>After you have sent money to our account, your transaction status will not change right away. This does not mean that your money hasn't been received. The transaction status will only change after the money is credited into your receiver's account.</p>
                         
                        </div>
                    </div>
                  </div>

                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse69">I raised a transaction on late Friday evening. When will the transaction get completed?</a>
                        </h4>
                    </div>
                    <div id="collapse69" class="panel-collapse collapse">
                        <div class="panel-body">
                           <p>Transactions where money is received in our account after office hours on Friday or on the eve of a public holiday, will get processed on the subsequent working day. Remittances to India will usually be completed within 2 to 5 working hours, after banks open in India on Monday morning. Other corridors will be processed as per the stated processing times.</p>
                         
                        </div>
                    </div>
                  </div>

                 


                  <!-- end troubleshoot -->

                  <!-- payment -->
                  <div class="faqHeader">Payment</div>
                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse71">How do I pay by bank transfer?</a>
                        </h4>
                    </div>
                    <div id="collapse71" class="panel-collapse collapse">
                        <div class="panel-body">
                            <p><b>After you create a transaction, we will show you the payment instructions. They will include:</b></p>
                           
                            <ul>
                                <li>A unique transaction reference number</li>
                                <li>The amount you need to send</li>
                                <li>Our bank account details</li>
                            </ul>
                            <p>
                                You can make this transfer online. Simply go to your bank’s website, log into your Internet Banking service and make the transfer. Please also check other options, specified on our website. It is important that you enter the transaction reference number in the remarks or description field when sending the money through online banking.
                            </p>
                        </div>
                    </div>
                  </div>

                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse72">Can I pay by cheque, cash or card?</a>
                        </h4>
                    </div>
                    <div id="collapse72" class="panel-collapse collapse">
                        <div class="panel-body">
                           <p>Sorry, we do not accept cheque or cash payment. As of now, we have not enabled payment by credit or debit card.</p>
                        </div>
                    </div>
                  </div>

                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse73">What about joint bank accounts? </a>
                        </h4>
                    </div>
                    <div id="collapse73" class="panel-collapse collapse">
                        <div class="panel-body">
                           <p>Yes, you can transfer money from a joint account, if you are the main or second holder on that account.</p>
                         
                        </div>
                    </div>
                  </div>

                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse74">What is the unique transaction number?</a>
                        </h4>
                    </div>
                    <div id="collapse74" class="panel-collapse collapse">
                        <div class="panel-body">
                            <p>After you create a transaction, we will show you the payment instructions. They will include:</p>
                            <ul>
                            <li>A unique transaction reference number</li>
                            <li>The amount you need to send</li>
                            <li>Our bank account details</li>
                            </ul>
                            <p>The unique transaction number is used to uniquely identify your transaction and to track its status.</p>
                            <p>After completing the transaction, you will also receive an email and SMS notification containing the unique transaction reference number.</p>
                           
                        </div>
                    </div>
                  </div>

                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse75">In my bank's screen for making an online payment, there is no place to put in a Transaction Reference Number. What do I do?</a>
                        </h4>
                    </div>
                    <div id="collapse75" class="panel-collapse collapse">
                        <div class="panel-body">
                           <p>If you are unable to provide us the Transaction Reference Number as part of your bank transfer, that's okay. We can still match your payment to your transaction based on your name & account number. If there are multiple transactions of the same amount, SingX reserves the right to fulfil any one of the valid transactions that you have created.</p>
                        </div>
                    </div>
                  </div>

                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse76">I have created two transactions, but a bank transfer for one of them. How do I let you know which transaction I want to proceed with?</a>
                        </h4>
                    </div>
                    <div id="collapse76" class="panel-collapse collapse">
                        <div class="panel-body">
                            <p>SingX reserves the right to fulfil any one of the valid transactions that you have created.</p>
                            
                        </div>
                    </div>
                  </div>

                  <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse141">What is Source of Funds?</a>
                        </h4>
                    </div>
                    <div id="collapse141" class="panel-collapse collapse">
                        <div class="panel-body">
                            <p>Source of Funds refers to a document that demonstrates a person or entity has the ability and funds available for a specific transaction. The purpose of the source of funds document is to ensure that the funds needed to execute the transaction fully are legitimate.</p>
                            <ul>
                                <p>Examples of Source of funds document:</p>
                                <li>Bank statement</li>
                                <li>Salary slips</li>
                                <li>Tax Invoices</li>
                            </ul>
                            
                        </div>
                    </div>
                  </div>
                  <!-- end payment -->
                  <!-- account management -->
                <div class="faqHeader">Account Management</div>
                <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse81">How do I edit profile details?</a>
                        </h4>
                    </div>
                    <div id="collapse81" class="panel-collapse collapse">
                        <div class="panel-body">
                            <P>Please log in and you will see your Dashboard. Click on your name on the top right and select 'Profile' from the drop-down menu. Make the necessary changes to your personal profile details and save the changes.</P>
                        </div>
                    </div>
                </div>

                <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse82">How do I change my password?</a>
                        </h4>
                    </div>
                    <div id="collapse82" class="panel-collapse collapse">
                        <div class="panel-body">
                        <p>Please log in and you will see your Dashboard. Click on your name on the top right and select 'Change Password' from the drop-down menu. Make the necessary changes and save.
                            <br><br>
                            If you forget your username/password or are unable to sign in, click on “Forgot password?” link on the login page. Our password policy is as follows:
                         </p> 
                            <ul>
                                <li>Minimum 8 alphanumeric characters password.</li>
                                <li>At least one letter in uppercase.</li>
                                <li>Must not repeat any letter or number.</li>
                            </ul>	
                        </div>
                    </div>
                </div>

                <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse83">How do I change my email address?</a>
                        </h4>
                    </div>
                    <div id="collapse83" class="panel-collapse collapse">
                        <div class="panel-body">
                        <p> To change your email address, please write to us at <a href="mailto:help.au@singx.co">help.au&#64;singx.co</a></p>	
                        </div>
                    </div>
                </div>

                <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse84">How do I change my mobile number?</a>
                        </h4>
                    </div>
                    <div id="collapse84" class="panel-collapse collapse">
                        <div class="panel-body">
                        <p>To change your mobile number, please write to us at <a href="mailto:help.au@singx.co">help.au&#64;singx.co</a></p>	
                        </div>
                    </div>
                </div>

                <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse85">How do I add/delete my receiver's bank account?</a>
                        </h4>
                    </div>
                    <div id="collapse85" class="panel-collapse collapse">
                        <div class="panel-body">
                            <b>Add an account</b> <br>
                            <ul>
                            <li>After you log into your account, you will find 'Manage Receivers' link on your dashboard.</li>
                            <li>To add a new receiver: Click on the '+Add' button and enter all the relevant information for the bank account you wish to send money to, and click Save. To confirm the new account, a One-Time Password (OTP) authentication is required. You will receive an OTP on your registered mobile number. Enter the OTP exactly as received and click confirm. Once validated, you will see the confirmation/summary for the bank account you have entered. You can select the receiver's bank from the dropdown list.</li>
                            </ul>
                              <b>Delete an account</b> <br>
                            <ul>
                            <li>To delete an existing receiver bank account: select the respective receiver's bank account and click 'De-activate'. Click 'Confirm' and the selected receiver's bank record will be listed as inactive.</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse86">How do I add/delete my (sender) bank account?</a>
                        </h4>
                    </div>
                    <div id="collapse86" class="panel-collapse collapse">
                        <div class="panel-body">
                            <b>Add an account</b> <br>				
                            <ul>
                            <li>After you log into your account, you will find 'Manage my bank accounts' link on your dashboard.</li>
                            <li>To add new bank details: Click on '+ Add', and enter your new bank details. You can search for your bank by entering the bank name. Click 'Add sender' after all information has been completed. You will now see the new bank details listed on the 'My bank accounts' page.</li>
                            </ul>
                             <b>Delete an account</b> <br>	
                            <ul>
                            <li>We do not allow customers to delete the sender account details due to transaction processing. However, if you wish to delete an account after your transaction has been processed, please write to us at <a href="mailto:help.au@singx.co"> help.au&#64;singx.co</a></li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse87">What details do I need to add a receiver's account?</a>
                        </h4>
                    </div>
                    <div id="collapse87" class="panel-collapse collapse">
                        <div class="panel-body">	
                            <p>Please ensure you ask the receiver for (i) the receiver's name (ii) receiver's account number and (iii) the receiver's bank name. In addition:
                                Please read the tooltip before setting up a new receiver.</p> 
                                
                        </div>
                    </div>
                </div>

                <div class="faqHeader">Technical & Browser Queries</div>
                <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse91">What Internet browsers do you support?</a>
                        </h4>
                    </div>
                    <div id="collapse91" class="panel-collapse collapse">
                        <div class="panel-body">
                            <p>Our website is optimised for Safari (version 8 and above) and Google Chrome (Version 43 and above). If you are using our mobile apps (Android or iOS) please ensure that you have updated the app to the latest version that is available.</p>
                        </div>
                    </div>
                </div>

                <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse92">How do I enable cookies?</a>
                        </h4>
                    </div>
                    <div id="collapse92" class="panel-collapse collapse">
                        <div class="panel-body">
                            <b>Google Chrome:</b>
                            <ul>
                            <li>Select 'Settings' from browser menu list.</li>
                            <li>Select 'Show advanced settings...' at the bottom of the page.</li>
                            <li>Under the heading 'Privacy', select 'Content Settings'.</li>
                            <li>Under the heading 'Cookies', select 'Allow local data to be set' and make sure 'Block third-party cookies and site data' is unticked.</li>
                            <li>Click 'Done' in the bottom right-hand corner of the popup window.</li>
                            </ul>
        
                            <b>Safari:</b>
                            <ul>
                            <li>Select 'Safari', next to the Apple logo.</li>
                            <li>Select 'Preferences...', from the drop down menu.</li>
                            <li>Select 'Privacy' in the popup window.</li>
                            <li>In the category 'Cookies and website data', select 'Allow from websites I visit'.</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse93">How do I clear my cache?</a>
                        </h4>
                    </div>
                    <div id="collapse93" class="panel-collapse collapse">
                        <div class="panel-body">
                           <p><b>Google Chrome:</b></p> 
                             <p>Select 'Preference' from browser menu list.</p> 
                            <p>Select 'Show advanced settings...' at bottom of the page.</p>
                            <p>Under the heading 'Privacy', select 'Clear browsing data...'.</p>
                            <p>At the top of the popup window, next to 'Obliterate the following items from:' select your desired duration to clear. (Recommended to be at least 'the last 4 weeks'.)</p>
                            <p>Tick 'Cached images and files'.</p>
                            <p>Click 'Clear browsing data'.</p>
                           
                            <p><b>Safari:</b></p>
                            <p>Select 'Safari', next to the Apple logo.</p>
                            <p>Select 'Preferences...', from drop-down menu.</p>
                            <p>Select the furthest right tab 'Advanced' in popup window.</p>
                            <p>At the bottom of the 'Advanced' window, you should see the option 'Show Develop menu in menu bar'. Tick this.</p>
                            <p>Close popup window.</p>
                            <p>Top of the screen, click on 'Develop' between 'Bookmarks' and 'Window'.</p>
                            <p>In the drop-down menu, click on 'Empty Caches'.</p>
                           
                        </div>
                    </div>
                </div>

                <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse94">How do I take a screenshot?</a>
                        </h4>
                    </div>
                    <div id="collapse94" class="panel-collapse collapse">
                        <div class="panel-body">
                                <p>For Apple MacBook, press command + shift + 3 buttons and screenshot image will be saved on your desktop.</p>
                                <p>For Windows, press Print Screen key and paste to image editor to save the screenshot.</p>
                                <p>For iPhone or iPad, hold down home + lock buttons and screenshot will be saved into camera roll.</p>
                                <p>For Android, please refer to the brand and model manual.</p>
                            
                        </div>
                    </div>
                </div>


                <div class="faqHeader">Security</div>
                <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse101">Is my personal data safe?</a>
                        </h4>
                    </div>
                    <div id="collapse101" class="panel-collapse collapse">
                        <div class="panel-body">
                            <p>We take the safety of your personal details very seriously. To facilitate secure data transmission over the Internet, we have all the safety precautions in place. We have adopted a two-step authentication process which ensures complete security and peace of mind. We also ensure that our website keeps your connection secure. All your account information is stored in a secure facility that is safeguarded by us.</p>
                        </div>
                    </div>
                </div>

                <!-- end global faqs -->
                	<!-- currency alert start here -->
                    <div class="faqHeader">Rate Alert</div>
                    <div class="panel panel-default">
                        <div class="panel-heading">
                            <h4 class="panel-title">
                                <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse111">Do I need to register with SingX to create a rate alert?</a>
                            </h4>
                        </div>
                        <div id="collapse111" class="panel-collapse collapse">
                            <div class="panel-body">
                                <p class=" regular10 color_lightgrey">No, you do not need to register with SingX to subscribe for our rate alerts. However certain features are only available to registered users, hence for full access we recommend that you create an account. Registration is free and easy, <a href="javascript:void(0)" (click)="redirectToRegistrationPage()" >here</a> to sign up now.</p>
                            </div>
                        </div>
                    </div>

                    <div class="panel panel-default">
                        <div class="panel-heading">
                            <h4 class="panel-title">
                                <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse112">Does it cost me anything to setup a rate alert?</a>
                            </h4>
                        </div>
                        <div id="collapse112" class="panel-collapse collapse">
                            <div class="panel-body">
                                <p class=" regular10 color_lightgrey">No, setting up rate alerts with SingX is free of charge for all users. We aim to keep you updated with our live exchange rates so that you can transact at the rates you want!.</p>
                            </div>
                        </div>
                    </div>

                    <div class="panel panel-default">
                        <div class="panel-heading">
                            <h4 class="panel-title">
                                <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse113">What are the different types of rate alert that SingX offers?</a>
                            </h4>
                        </div>
                        <div id="collapse113" class="panel-collapse collapse">
                            <div class="panel-body">
                                <ul>
                                    <li>Rate reaches your desired value: Alert if the rate of the currency pair selected reaches your specified value
                                    </li>
                                    <li>Rate is at its Two-weeks high: Alert if the rate of the currency pair selected is the highest in the past two weeks</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div class="panel panel-default">
                        <div class="panel-heading">
                            <h4 class="panel-title">
                                <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse114">Can I set multiple rate alerts for the same currency pair? (i.e. Three different rate alerts for SGD to INR)</a>
                            </h4>
                        </div>
                        <div id="collapse114" class="panel-collapse collapse">
                            <div class="panel-body">
                                <p>At this time, you can only set one rate alert for each currency pair. However, you can have both types of rate alert set up for the same currency pair. The two types of alert offered on SingX are: a) Rate reaches your desired value b) Rate is at its Two-weeks high. You may edit this rate alert by logging in to your SingX account and selecting Rate Alerts > Manage Alerts.</p>
					
                            </div>
                        </div>
                    </div>

                    <div class="panel panel-default">
                        <div class="panel-heading">
                            <h4 class="panel-title">
                                <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse115">Can I receive the same rate alert via both SMS and Email?</a>
                            </h4>
                        </div>
                        <div id="collapse115" class="panel-collapse collapse">
                            <div class="panel-body">
                                <p>This option is available for all registered users of SingX. If you wish to receive the same type of rate alert via both Email and SMS, then please select “Both” option in the channel of communication.</p>
					
                            </div>
                        </div>
                    </div>

                    <div class="panel panel-default">
                        <div class="panel-heading">
                            <h4 class="panel-title">
                                <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse116">Does the foreign exchange rate involve any markups?</a>
                            </h4>
                        </div>
                        <div id="collapse116" class="panel-collapse collapse">
                            <div class="panel-body">
                                <p>SingX endevaours to provides 100% transparency with no hidden fees or foreign exchange markups.</p>
					
                            </div>
                        </div>
                    </div>

                    <div class="panel panel-default">
                        <div class="panel-heading">
                            <h4 class="panel-title">
                                <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse117">Will you hold the foreign exchange rate that I receive via the rate alert email/SMS notification for me to transact at?</a>
                            </h4>
                        </div>
                        <div id="collapse117" class="panel-collapse collapse">
                            <div class="panel-body">
                               
					      <p>Unfortunately, no. SingX provides live foreign exchange rates that are always fluctuating. Hence, we are unable to hold a specific rate indicated in the rate alert for customers. If you would like to enjoy the FX rate indicated in the rate alert, please log on to the SingX portal and book a transaction as soon as possible. After this, you will need to transfer the funds to SingX as indicated on the transaction page.</p>
					
                            </div>
                        </div>
                    </div>

                    <div class="panel panel-default">
                        <div class="panel-heading">
                            <h4 class="panel-title">
                                <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse118">How many times will I receive alerts if the foreign exchange rate exceeds the limit that I set? (i.e. I set up an alert if 1 SGD crosses 46 INR)</a>
                            </h4>
                        </div>
                        <div id="collapse118" class="panel-collapse collapse">
                            <div class="panel-body">
                                <p>We will send you rate alerts five times if the rate crosses your set limit. For example, if you set a rate alert of 1 AUD to go above 46 INR, the rate alert notification will be sent 5 times (1 per day) when the rate goes above 46. After receiving the alert 5 times, you will then receive an email notification to set a new rate alert if you wish to continue receiving the alerts.</p>
					
                            </div>
                        </div>
                    </div>

                    <div class="panel panel-default">
                        <div class="panel-heading">
                            <h4 class="panel-title">
                                <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse119">How does a two-week high alert work?</a>
                            </h4>
                        </div>
                        <div id="collapse119" class="panel-collapse collapse">
                            <div class="panel-body">
                                <p>If the rate for your currency pair is the highest in the past two weeks, you will receive a rate alert. For example, if you set a two-week high rate alert for AUD to USD, you will receive an alert if this condition is met. The two-week high rate alerts will be sent 5 times, after which you will receive an email notification to set a new rate alert if you wish to continue receiving the alerts.</p>
					
                            </div>
                        </div>
                    </div>

                    <div class="panel panel-default">
                        <div class="panel-heading">
                            <h4 class="panel-title">
                                <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse1110">How can I edit my existing alerts?</a>
                            </h4>
                        </div>
                        <div id="collapse1110" class="panel-collapse collapse">
                            <div class="panel-body">
                                <ul>
                                    <li>
                                        If you are a registered user with SingX: log in to your account, click on your profile, select Rate Alerts-> Manage Alerts. You can edit your existing alert by clicking on the edit icon shown at the end.
                                    </li>
                                      <li>If you are not a registered user with SingX, you are unable to edit your alert. However, you can delete the alert by using the unsubscribe link in the rate alert email and then create a new one.</li>
                                      </ul>	
                            </div>
                        </div>
                    </div>

                    <div class="panel panel-default">
                        <div class="panel-heading">
                            <h4 class="panel-title">
                                <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse1111">How many times will I receive rate alerts in one day?</a>
                            </h4>
                        </div>
                        <div id="collapse1111" class="panel-collapse collapse">
                            <div class="panel-body">
                                <p>You will receive one rate alert every 24 hours.</p>
					
                            </div>
                        </div>
                    </div>

                    <div class="panel panel-default">
                        <div class="panel-heading">
                            <h4 class="panel-title">
                                <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse1112">How do I unsubscribe from the rate alerts?</a>
                            </h4>
                        </div>
                        <div id="collapse1112" class="panel-collapse collapse">
                            <div class="panel-body">
                            
                                    <ul>
                                      <li>If you are a registered user with SingX: log in to your account, click on your profile, select Rate Alerts-> Manage Alerts and simply delete the alerts you would like to unsubscribe from.</li>
                                      <li>If you are not a registered user with SingX, simply click on the unsubscribe link in the SingX rate alert emails you have reeived.</li>
                                      </ul>
                            </div>
                        </div>
                    </div>

                    <div class="panel panel-default">
                        <div class="panel-heading">
                            <h4 class="panel-title">
                                <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse1113">Can I share the rate alert with my friends?</a>
                            </h4>
                        </div>
                        <div id="collapse1113" class="panel-collapse collapse">
                            <div class="panel-body">
                            
                                <p>Absolutely! Feel free to share this rate with your friends on social media or via email to help them enjoy unbeatable exchange rates with SingX.</p>
					
					
                            </div>
                        </div>
                    </div>

                    <div class="panel panel-default">
                        <div class="panel-heading">
                            <h4 class="panel-title">
                                <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse1114">Who can I contact if I still have questions?</a>
                            </h4>
                        </div>
                        <div id="collapse1114" class="panel-collapse collapse">
                            <div class="panel-body">
                                <p>Feel free to contact our helpful customer service team at <a href="mailto:help.au@singx.co ">help.au&#64;singx.co</a> so they can guide you through the process of setting up rate alerts on our website.</p>
                            </div>
                        </div>
                      
                    </div>
                 
                    <!-- currency alert end here -->

                </div>
            </div>
            <!--end container -->
          
        </div>
      
        <!--end services-wrapper -->
    </section>
    <!-- End FAQs for AU -->

    <!-- footer -->
    <app-footer></app-footer>